<template>
<div>
  <div class='condition' v-if="!isSimple">
    <el-scrollbar style="height:100%" class="condition-scrollbar">
      <div class='condition-title'>
        <span>{{$t('T_BASIC_SETTINGS')}}</span>
      </div>
      <div class="room-input">
        <div class="roomsize-title ellipsis" :title="$t('T_ROOM_SIZE')">{{$t('T_ROOM_SIZE')}}</div>
        <div class="room-size-value" style="padding-left: 20px">
           <span class="room_block_input">
            <span class="w-title">{{$t('T_WIDTH')}}</span>
            <span class="ft_inch_item ft_inch_item-wdith" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
              <FtInput v-model="roomWData" :unitData="unitData" @blur='changeFtRoomWDataInput'></FtInput>
            </span>
            <span class="w-value ft_inch_item-wdith" v-else>
              <inputValidateBox prop='roomWData' :rules="rules.number">
                <el-input v-model='roomWData' @input="testDigital($event, 'roomWData')" class='roomsize_input' :disabled="isUSTWall"
                  @blur='changeMutation("roomWData", "SET_GRAPH_ROOMW", "changeRoomW")'
                  @keyup.enter.native='changeMutation("roomWData", "SET_GRAPH_ROOMW", "changeRoomW")'>
                </el-input>
                <span class="unit" :class="{'inch-font-size': unitLabel=== 'inch'}">{{unitLabel}}</span>
              </inputValidateBox>
            </span>
          </span>
          <br>
          <span class="room_block_input">
            <span class="w-title">{{$t('T_HEIGHT')}}</span>
            <span class="ft_inch_item ft_inch_item-wdith" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
              <FtInput v-model="roomHData" :unitData="unitData" @blur='changeMutation("roomHData", "SET_GRAPH_ROOMH", "changeRoomH")' :forceUpdate='roomHForceUpdate'></FtInput>
            </span>
            <span class="w-value ft_inch_item-wdith" v-else>
              <inputValidateBox prop='roomHData' :rules="rules.number">
                <el-popover placement="right" trigger="manual" :content="roomH_value_out_str" v-model="roomH_value_out">
                  <el-input slot="reference" v-model='roomHData' @input="testDigital($event, 'roomHData')" class='roomsize_input'
                    @blur='changeMutation("roomHData", "SET_GRAPH_ROOMH", "changeRoomH")'
                    @keyup.enter.native='changeMutation("roomHData", "SET_GRAPH_ROOMH", "changeRoomH")'>
                  </el-input>
                </el-popover>
                <span class="unit" :class="{'inch-font-size': unitLabel=== 'inch'}">{{unitLabel}}</span>
              </inputValidateBox>
            </span>
          </span>
          <br>
          <span class="room_block_input">
            <span class="w-title">{{$t('T_DEPTH')}}</span>
            <span class="ft_inch_item ft_inch_item-wdith" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
              <FtInput v-model="roomDData" :unitData="unitData" @blur='changeFtRoomDDataInput'></FtInput>
            </span>
            <span class="w-value ft_inch_item-wdith" v-else>
              <inputValidateBox prop='roomDData' :rules="rules.number">
                <el-input v-model='roomDData' class='roomsize_input' @input="testDigital($event, 'roomDData')" :disabled="isUSTWall"
                  @blur='changeMutation("roomDData", "SET_GRAPH_ROOMD", "roomDData")'
                  @keyup.enter.native='changeMutation("roomDData", "SET_GRAPH_ROOMD", "roomDData")'>
                </el-input>
                <span class="unit" :class="{'inch-font-size': unitLabel=== 'inch'}">{{unitLabel}}</span>
              </inputValidateBox>
            </span>
          </span>
        </div>
      </div>
      <div class='condition__bottom_radio'>
        <div class="aspect_ratio">
          <span>{{$t('T_POSITION')}}</span>
        </div>
        <div class="ratio-select">
          <el-select v-model="Position" @change="changePosition">
            <el-option :value="0" :label="$t('T_POS_DESKTOP')"></el-option>
            <el-option :value="1" :label="$t('T_POS_CEILING')" :disabled='isCellingDisable'></el-option>
            <el-option :value='2' :label="$t('T_POS_WALL')" :disabled='isWallDisable'></el-option>
          </el-select>
        </div>
      </div>
      <!-- 床からフットまで -->
      <!--Positionが「Wall」 or 「Ceiling」のときFloor to foot of projectorを表示しない-->
      <div class="room-input" v-if="Position == 0">
        <div class="room-size-value" style="padding-left: 20px">
          <span class="room_block_input">
              <!-- <span class="w-title2">{{$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT')}}</span> -->
              <span class="w-title2">
                {{$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT_NO_COLON')}}
              </span>
              <span class="checkbox " :class="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? 'lock-floor-fraction':'lock-floor'">
                <div class="suo-icon"></div>
                <el-checkbox v-model="floor_footProjector_checked"></el-checkbox>
              </span>
              <span class="ft_inch_item ft_inch_item-wdith2" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                <FtInput v-model="floor2footProjectorData" :unitData="unitData" @blur='changeFloor2footProjector()'></FtInput>
              </span>
              <span class="w-value ft_inch_item-wdith2" v-else>
                <inputValidateBox prop='floor2footProjectorData' :rules="rules.number">
                  <el-input v-model='floor2footProjectorData' class='roomsize_input' @input="testDigital($event, 'floor2footProjectorData')" :disabled="position === 1 || position === 2 || floor_footProjector_checked"
                    @blur='changeFloor2footProjector()'
                    @keyup.enter.native='changeFloor2footProjector()'>
                  </el-input>
                  <span class="unit" :class="{'inch-font-size': unitLabel=== 'inch'}">{{unitLabel}}</span>
                </inputValidateBox>
              </span>
            </span>
        </div>
      </div>
      <div class='condition__bottom_radio' v-if="whiteboardSupport">
        <div class="aspect_ratio">
          <span>{{$t('T_WHITE_BOARD')}}</span>
        </div>
        <div class="ratio-select">
          <el-select v-model="boardStatus" @change="changeBoardStatus">
            <el-option :value="0" :label="$t('T_ON')"></el-option>
            <el-option :value="1" :label="$t('T_OFF')"></el-option>
          </el-select>
        </div>
      </div>
      <div class='condition__bottom_radio' v-if="intFuncSupport">
        <div class="aspect_ratio">
          <span>{{$t('T_INTERACTIVE_FUNCTION')}}</span>
        </div>
        <div class="ratio-select">
          <el-select v-model="intFuncStatus" @change="changeDwhSelect">
            <el-option :value="0" :label="$t('T_ON')"></el-option>
            <el-option :value="1" :label="$t('T_OFF')"></el-option>
          </el-select>
        </div>
      </div>
      <!-- FingerTouch非対応モデルのときFingerTouchを表示しない -->
      <div class='condition__bottom_radio' v-if="!touchDisable">
        <div class="aspect_ratio">
          <span>{{$t('T_FINGER_TOUCH')}}</span>
        </div>
        <div class="ratio-select">
          <el-select v-model="touchStatus" @change="changeFingerStatus">
            <el-option :value="0" :label="$t('T_ON')"></el-option>
            <el-option :value="1" :label="$t('T_OFF')"></el-option>
          </el-select>
        </div>
      </div>
      <div class='condition__bottom_radio' v-if="whiteboardSupport">
        <div class="aspect_ratio">
          <span>{{$t('T_FTU_LOCATION')}}</span>
        </div>
        <div class="ratio-select">
          <el-select v-model="FTULocationStatus" :disabled="FTULocationDisable" @change="changeFingerStatus">
            <el-option :value="0" :label="$t('T_ON_BOARD')"></el-option>
            <el-option :value="1" :label="$t('T_ABOVE_BOARD')"></el-option>
          </el-select>
        </div>
      </div>
      <!-- Units -->
      <div class='condition__scale_radio'>
        <div class="aspect_ratio">
          <span>{{$t('T_SCALE')}}</span>
        </div>
        <div class="ratio-select">
          <el-select v-model="unitData">
            <el-option v-for="item in unitDataOptions" :key='item.value' :label='$t(item.value)' :value='item.value'>
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="curve_condition" v-if="!isUSTWall && searchTabActive === 'CurvedSurface'">
        <!-- <el-collapse v-model="curve_activeNames"  @change="handleCollapseChange" v-if="!isUSTWall"> -->
          <!-- <el-collapse-item :title="$t('T_CURVE_SCREEN_SHAPE')" name="1"> -->
            <div class='condition-title'>
              <span>{{$t('T_CURVE_SCREEN_SHAPE')}}</span>
            </div>
            <!-- 平面 凹面 凸面 -->
            <div class='curved_shape'>
              <div class="span_container">
                <span>{{$t('T_CURVE_SCREEN_SHAPE')}}</span>
              </div>
              <div class="select_container">
                <el-select v-model='shape_input'>
                  <el-option v-for='item in shape' :key='item.value' :label="$t(item.label)" :value='item.value'>
                  </el-option>
                </el-select>
              </div>
              <div class="clear"></div>
            </div>
            <CurveCondition ref="CurveCondition" :angleActive='angle_activeNames'></CurveCondition>
          <!-- </el-collapse-item> -->
        <!-- </el-collapse> -->
      </div>
      <div v-if="whiteboardSupport && whiteboardStatus">
        <div class='condition-title'>
          <span>{{$t('T_PROJECTION_SETTINGS')}}</span>
          <div class="checkbox">
            <div class="suo-icon"></div>
            <el-checkbox v-model="throw_distance_checked"></el-checkbox>
          </div>
        </div>
        <div class="board-input">
          <div class="roomsize-title ellipsis" :title="$t('T_BOARD_SIZE')">{{$t('T_BOARD_SIZE')}}</div>
          <div class="room-size-value" style="padding-left: 20px">
             <span class="room_block_input">
              <span class="w-title">{{$t('T_WIDTH')}}</span>
              <span class="ft_inch_item ft_inch_item-wdith" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                <FtInput v-model="boardWData" :unitData="unitData" @blur='changeMutation("boardWData", "BOARDW", "changeDwhSelect")'></FtInput>
              </span>
              <span class="w-value ft_inch_item-wdith" v-else>
                <inputValidateBox prop='boardWData' :rules="rules.number">
                  <el-input v-model='boardWData' @input="testDigital($event, 'boardWData')" class='roomsize_input' :disabled="throw_distance_checked"
                    @blur='changeMutation("boardWData", "BOARDW", "changeDwhSelect")'
                    @keyup.enter.native='changeMutation("boardWData", "BOARDW", "changeDwhSelect")'>
                  </el-input>
                  <span class="unit" :class="{'inch-font-size': unitLabel=== 'inch'}">{{unitLabel}}</span>
                </inputValidateBox>
              </span>
            </span>
            <br>
            <span class="room_block_input">
              <span class="w-title">{{$t('T_HEIGHT')}}</span>
              <span class="ft_inch_item ft_inch_item-wdith" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                <FtInput v-model="boardHData" :unitData="unitData" @blur='changeMutation("boardHData", "BOARDH", "changeDwhSelect")'></FtInput>
              </span>
              <span class="w-value ft_inch_item-wdith" v-else>
                <inputValidateBox prop='boardHData' :rules="rules.number">
                  <el-input v-model='boardHData' @input="testDigital($event, 'boardHData')" class='roomsize_input' :disabled="throw_distance_checked"
                    @blur='changeMutation("boardHData", "BOARDH", "changeDwhSelect")'
                    @keyup.enter.native='changeMutation("boardHData", "BOARDH", "changeDwhSelect")'>
                  </el-input>
                  <span class="unit" :class="{'inch-font-size': unitLabel=== 'inch'}">{{unitLabel}}</span>
                </inputValidateBox>
              </span>
            </span>
            <br>
            <span class="room_block_input">
              <span class="w-title">{{$t('T_THICKNESS')}}</span>
              <span class="ft_inch_item ft_inch_item-wdith" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                <FtInput v-model="offsetData" :unitData="unitData" @blur='changeMutation("offsetData", "SET_OFFSET")' :forceUpdate="offsetDataForceUpdate"></FtInput>
              </span>
              <span class="w-value ft_inch_item-wdith" v-else>
                <inputValidateBox prop='offsetData' :rules="rules.number">
                  <el-input class="roomsize_input" v-model='offsetData' :disabled="throw_distance_checked" @blur='changeMutation("offsetData", "SET_OFFSET")' @input="testDigital($event, 'offsetData')" @keyup.enter.native='changeMutation("offsetData", "SET_OFFSET")'></el-input>
                  <span class="unit" :class="{'inch-font-size': unitLabel=== 'inch'}">{{unitLabel}}</span>
                </inputValidateBox>
              </span>
            </span>
          </div>
        </div>
        <div class='screen_size_floor_ust'>
          <div class="screen-position-ft ellipsis">
            <span :title="$t('T_FLOOR_TO_BOTTOM_WHITEBOARD')">{{$t('T_FLOOR_TO_BOTTOM_WHITEBOARD')}}</span>
          </div>
          <span class="ft_inch_item" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
              <FtInput v-model="floor2bottomData" :unitData="unitData" @blur='changeFloorMutation()'></FtInput>
          </span>
          <span class="screen-position_input" v-else>
            <inputValidateBox prop='floor2bottomData' :rules="rules.number">
              <el-input class="roomsize_input" v-model='floor2bottomData' @blur='changeFloorMutation()' @input="testDigital($event, 'floor2bottomData')" @keyup.enter.native='changeFloorMutation()' :disabled="throw_distance_checked"></el-input>
              <span class='m' style="margin-left:-3px">{{unitLabel}}</span>
            </inputValidateBox>
          </span>
        </div>
      </div>
      <div class='condition-screen'>
        <div class='condition-title'>
          <span>{{$t('T_SCREEN_SIZE')}}</span>
          <div class="checkbox">
            <div class="suo-icon"></div>
            <el-checkbox v-model="screen_size_checked"></el-checkbox>
          </div>
        </div>
        <!-- <div class="screen-size">
          <span class="screen-size-span">{{$t('T_DIAGONAL')}}</span>
          <div class="screen-diagonal">
            <inputValidateBox prop='screenSizeData' :rules="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? rules.numberValid : rules.number" :outVisible="'true'">
              <el-popover placement="right" trigger="manual" :content="screen_value_out_str" v-model="screen_value_out">
                <el-input slot="reference" v-model='screenSizeData' class='roomsize_input' @input="testDigital($event, 'screenSizeData')" @blur='changeScreenSize' @keyup.enter.native='changeScreenSize' :disabled="screen_size_checked"></el-input>
              </el-popover>
              <span class="unit">inch</span>
            </inputValidateBox>
          </div>
          <div class="screen-width">
            <inputValidateBox prop='scrnWData' :rules="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? rules.numberValid : rules.number">
              <span class="screen-size-span">{{$t('T_WIDTH')}}</span>
              <el-input v-model='scrnWData' class='roomsize_input' @input="testDigital($event, 'scrnWData')"
                @blur='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")' @keyup.enter.native='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")' :disabled="screen_size_checked"></el-input>
              <span class="unit">{{unitLabel}}</span>
            </inputValidateBox>
          </div>
        </div>
        <div class="screen-height">
          <inputValidateBox prop='scrnHData' :rules="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? rules.numberValid : rules.number">
            <span class="screen-size-span">{{$t('T_HEIGHT')}}</span>
            <el-input v-model='scrnHData' class='roomsize_input'  @input="testDigital($event, 'scrnHData')"
              @blur='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")' @keyup.enter.native='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")' :disabled="screen_size_checked"></el-input>
            <span class="unit">{{unitLabel}}</span>
          </inputValidateBox>
        </div> -->
        <div class='screen_size_aspect'>
          <div class="aspect_ratio ellipsis">
            <span :title="$t('T_ASPECT_RATIO')">{{$t('T_ASPECT_RATIO')}}</span>
          </div>
          <!-- Aspect ratio -->
          <div class="ratio-select">
            <el-select v-model="aspectRatioData" @change='changeAspectRatio' :disabled="screen_size_checked">
                <el-option v-for="item in selectedLensOptions" :key='item.key' :label='item.value' :value='item.key'>
                </el-option>
            </el-select>
          </div>
        </div>

        <!-- screen size下的select -->
        <div class='screen_size_aspect'>
          <div class="screen-select">
            <el-select v-model="dwhSelect" :disabled="screen_size_checked" @change="changeDwhSelect">
                <el-option v-for="item in dwhSelectOptions" :key='item.value' :label='$t(item.label)' :value='item.value'>
                </el-option>
            </el-select>
          </div>
          <div class="screensize-wdh ellipsis">
              <div class="screen-diagonal" v-if="dwhSelect==='0'">
                <inputValidateBox prop='screenSizeData' :rules="rules.number" :outVisible="'true'">
                  <el-popover placement="right" trigger="manual" :content="screen_value_out_str" v-model="screen_value_out">
                    <el-input slot="reference" v-model='screenSizeData' class='roomsize_input' :class="{'dwh_out_of_spec': isOutOfSpec}" @input="testDigital($event, 'screenSizeData')" @blur='changeScreenSize' @keyup.enter.native='changeScreenSize' :disabled="screen_size_checked"></el-input>
                  </el-popover>
                  <span class="unit">inch</span>
                </inputValidateBox>
              </div>
              <div class="screen-width" v-if="dwhSelect==='1'">
                 <span class="ft_inch_item" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                   <FtInput v-model="scrnWData" :unitData="unitData" @blur='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")' :forceUpdate="scrnWForceUpdate"></FtInput>
                 </span>
                <span v-else>
                  <inputValidateBox prop='scrnWData' :rules="rules.number">
                    <el-input v-model='scrnWData' class='roomsize_input' @input="testDigital($event, 'scrnWData')" :class="{'dwh_out_of_spec': isOutOfSpec}"
                      @blur='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")' @keyup.enter.native='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")' :disabled="screen_size_checked"></el-input>
                    <span class="unit">{{unitLabel}}</span>
                  </inputValidateBox>
                </span>
              </div>
              <div class="screen-height" v-if="dwhSelect==='2'">
                <span class="ft_inch_item" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                  <FtInput v-model="scrnHData" :unitData="unitData" @blur='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")' :forceUpdate="scrnHForceUpdate"></FtInput>
                </span>
                <span v-else>
                  <inputValidateBox prop='scrnHData' :rules="rules.number">
                    <el-input v-model='scrnHData' class='roomsize_input'  @input="testDigital($event, 'scrnHData')" :class="{'dwh_out_of_spec': isOutOfSpec}"
                      @blur='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")' @keyup.enter.native='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")' :disabled="screen_size_checked"></el-input>
                    <span class="unit">{{unitLabel}}</span>
                  </inputValidateBox>
                </span>
              </div>
            <!-- <inputValidateBox prop='dwhDataDetailData' :rules="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? rules.numberValid : rules.number">
              <el-input v-model='dwhDataDetailData' class='roomsize_input' @blur="changeDwhData()" @change="changeDwhData" :class="{'dwh_out_of_spec': isOutOfSpec}"   :disabled="screen_size_checked"></el-input>
              <span class="unit" v-if="dwhSelect==='0'">inch</span>
              <span class="unit" v-if="dwhSelect!=='0'">{{unitLabel}}</span>
            </inputValidateBox> -->
          </div>
        </div>
        <div class="out_of_spec_warning" v-if="isOutOfSpec">
          <img src='../../assets/parts/icon/TDC_warning.png'/>
          <span class="out_of_spec_warning_span">{{$t('T_OUT_OF_SPEC_MODE')}}</span>
        </div>
        <!-- Screen size的slider滑块 Advanced-->
        <div class="screen-size_sliderbar" v-if="!isOutOfSpec">
          <div class="sld throw_dis_sld" v-show="real_throw_distance_checked">
            <div class="border" ref="throwDisLine"></div>
            <el-slider ref='realThrowDisSliderRangeFlag' v-model="realThrowDisSliderRangeData" :step="0.001" :show-tooltip="false"
              class="throw_distance_slider pjy-slider" :min="0" :max="realThrowDisSliderRangeMax"></el-slider>
            <label class="lab" ref = "distanceLockedSizetFormat" style="position: absolute;top: 10px;">{{distanceLockedSizetFormat}}</label>
            <label class="lab" ref = "distanceLockedSizewFormat" style="position: absolute;top: 45px;">{{distanceLockedSizewFormat}}</label>
          </div>
          <div class="sld screen_size_sld" v-show="!real_throw_distance_checked">
            <el-slider ref="screenSizeSliderFlag" v-showTip v-model="screenSizeSlider" :disabled="screen_size_checked" :step="0.001" :show-tooltip="false" class="throw_distance_slider" @change="screenChanged"  :min="ratioScreenSizeMin" :max="ratioScreenSizeMax"></el-slider>
          </div>
          <label class="lab" style="margin-left:10px">{{diagonalMinFormat}}</label>
          <label class="lab" style="float:right;margin-right:10px">{{diagonalMaxFormat}}</label>
        </div>
        <div v-if="!whiteboardSupport || !whiteboardStatus">
          <div class='condition-title'>
            <span>{{$t('T_SCREEN_POSITION')}}</span>
            <div class="checkbox">
              <div class="suo-icon"></div>
              <el-checkbox v-model="throw_distance_checked"></el-checkbox>
            </div>
          </div>
          <div class='screen_size_floor'>
            <div class="screen-position-ft ellipsis">
              <span :title="$t('T_FLOOR_TO_BOTTOM')">{{$t('T_FLOOR_TO_BOTTOM')}}</span>
            </div>
            <span class="ft_inch_item" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                <FtInput v-model="floor2bottomData" :unitData="unitData" @blur='changeFloorMutation()'></FtInput>
            </span>
            <span class="screen-position_input" v-else>
              <inputValidateBox prop='floor2bottomData' :rules="rules.number">
                <el-input class="roomsize_input" v-model='floor2bottomData' @blur='changeFloorMutation()' @input="testDigital($event, 'floor2bottomData')" @keyup.enter.native='changeFloorMutation()' :disabled="throw_distance_checked"></el-input>
                <span class='m' style="margin-left:-3px">{{unitLabel}}</span>
              </inputValidateBox>
            </span>
          </div>
          <!--ボードの厚み -->
          <div class='screen_size_offset'>
            <div class="screen-position-ft">
              <span v-if="isUSTWall">{{$t('T_THICKNESS_BOARD')}}(0 ~ {{ustOffsetMax}} {{unitLabel}})</span>
              <span v-else>{{$t('T_SCREEN_OFFSET')}}</span>
            </div>
            <span class="ft_inch_item" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
              <FtInput v-model="offsetData" :unitData="unitData" @blur='changeMutation("offsetData", "SET_OFFSET")' :forceUpdate="offsetDataForceUpdate"></FtInput>
            </span>
            <div class="screen-position_input" v-else>
              <inputValidateBox prop='offsetData' :rules="rules.number">
                <el-input class="roomsize_input" v-model='offsetData' :disabled="searchTabActive === 'CurvedSurface'" @blur='changeMutation("offsetData", "SET_OFFSET")' @input="testDigital($event, 'offsetData')" @keyup.enter.native='changeMutation("offsetData", "SET_OFFSET")'></el-input>
                <span class='m' style="margin-left:-3px">{{unitLabel}}</span>
              </inputValidateBox>
            </div>
          </div>
        </div>
        <!-- Throw distance 的checkbox -->
        <div class='condition-title'>
          <span>{{$t('T_THROW_DISTANCE')}}</span>
          <div class="checkbox">
            <div class="suo-icon"></div>
            <el-checkbox v-model="real_throw_distance_checked"></el-checkbox>
          </div>
        </div>
        <div class='throw_distance'>
        <div class="screen-position-ft ellipsis">
          <span :title="$t('T_SCREEN_TO_LENS')" v-if="!isUSTWall">{{$t('T_SCREEN_TO_LENS')}}</span>
          <span :title="$t('T_SCREEN_TO_PJ_DISTANCE')" v-else>{{$t('T_SCREEN_TO_PJ_DISTANCE')}}</span>
        </div>
         <span class="ft_inch_item" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
            <FtInput v-model="pjYData" :unitData="unitData" @blur='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")' :forceUpdate="pjYDataForceUpdate"></FtInput>
        </span>
        <div class="screen-position_input" v-else>
          <inputValidateBox prop='pjYData' :rules="rules.number">
            <el-popover placement="right" trigger="manual" :content="pjY_value_out_str" v-model="pjY_value_out">
              <el-input slot="reference" class="roomsize_input" v-model='pjYData' :disabled="screen2LensFlag || real_throw_distance_checked" @input="testDigital($event, 'pjYData')" @blur='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")' @keyup.enter.native='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")'>
              </el-input>
            </el-popover>
            <span class='m' style="margin-left:-3px">{{unitLabel}}</span>
          </inputValidateBox>
        </div>
        </div>
        <!-- Throw distance的slider滑块 Advanced-->
      <div class="condition_sliderbar" v-if="!isOutOfSpec">
        <div class="sld throw_dis_sld" v-if="!real_throw_distance_checked" :class="{'throw_slider' : real_throw_distance_checked}">
          <div class="border" ref="throwDisLine"></div>
           <el-slider ref='throwDisSliderRangeFlag' v-model="throwDisSliderRangeData" @change="throwDisChangedSizeLocked" :show-tooltip="false" :step="0.001" :disabled="!screen_size_checked || real_throw_distance_checked"
            class="throw_distance_slider pjy-slider" :min="0" :max="throwDisSli"
            :style="{left: sliderL + '%'}" :class="screen_size_checked ? 'block':'none'"></el-slider>
          <label class="lab" :style="{left: sliderL - 5 + '%'}" style="position: absolute;top: 10px;">{{throwDisSliderwFormat}}</label>
          <label class="lab" :style="{left: slidertL - 8 + '%'}" style="position: absolute;top: 45px;" v-if="throwDisSliderwFormat!=throwDisSlidertFormat">{{throwDisSlidertFormat}}</label>
        </div>
        <div class="sld throw_dis_sld" :class="{'throw_slider' : real_throw_distance_checked, 'check' : !real_throw_distance_checked}">
          <el-slider v-model="throwDisSliderData" ref="throwDisSliderFlag" v-showTipDis @change="throwDisChanged" :disabled="screen_size_checked || real_throw_distance_checked" :show-tooltip="false" class="throw_distance_slider pjy-slider-T" :step="0.001" :min="throwDisSliderMin" :max="throwDisSliderMax" :class="screen_size_checked ? 'none':'block'"></el-slider>
        </div>
        <label class="lab" style="margin-left:10px">{{throwDisSliderMinFormat}}</label>
        <label class="lab" style="float:right;margin-right:10px">{{throwDisSliderMaxFormat}}</label>
      </div>
      <div class='condition-title'>
        <span>{{$t('T_ADVANCED_SETTINGS')}}</span>
      </div>
      <div class='condition-projector' v-if="!isUSTWall">
        <el-collapse v-model="angle_activeNames">
          <el-collapse-item :title="$t('T_PJ_ANGLE')" name="1">
            <div class='indicate_switch'>
                <div class="indicate_text ellipsis">
                  <span>{{$t('T_INDICATE_THE_SCREEN_POSITION')}}</span>
                </div>
                <div class='indicate_switch_btn'>
                  <el-switch v-model='indAngleSwitchData' :width='switch_width' :disabled="(touchWallFlag && !indAngleSwitch) || searchTabActive === 'CurvedSurface'"></el-switch>
                </div>
                <!-- <div class="project-angle_input">
                  <el-input class="roomsize_input" v-model='vAngleData' :class="{red_out:isVAngleOut && vAngleFlagData}" @input="testDigitalNegative($event, 'vAngleData')" :disabled="!vAngleFlagData" @blur='changeAngleData("vAngleData", "SET_VANGLE")' @keyup.enter.native='changeAngleData("vAngleData", "SET_VANGLE")'></el-input>
                </div>
                <span class='m'>°</span> -->
            </div>
            <div class='vertical_switch'>
                <div class="vertical_text">
                  <span>{{$t('T_PJ_ANGLE_V')}}</span>
                </div>
                <div class='switch'>
                  <el-switch v-model='vAngleFlagData' :width='switch_width' @change="changeAngle('vAngleFlagData', 'SET_HANGLEFLAG')"></el-switch>
                </div>
                <div class="project-angle_input">
                  <el-input class="roomsize_input" v-model='vAngleData' :class="{red_out:(!indAngleSwitch && isVAngleOut && vAngleFlagData)||(indAngleSwitch && !isOnCornerAreas && vAngleFlagData)}" @input="testDigitalNegative($event, 'vAngleData')" :disabled="!vAngleFlagData" @blur='changeAngleData("vAngleData", "SET_VANGLE")' @keyup.enter.native='changeAngleData("vAngleData", "SET_VANGLE")'></el-input>
                </div>
                <span class='m'>°</span>
            </div>
            <div class='horizonal_switch'>
              <div class="vertical_text ellipsis" :title="$t('T_PJ_ANGLE_H')">
                <span>{{$t('T_PJ_ANGLE_H')}}</span>
              </div>
              <div class='switch'>
                <el-switch v-model='hAngleFlagData' :width='switch_width' @change="changeAngle('hAngleFlagData', 'SET_VANGLEFLAG')"></el-switch>
              </div>
              <div class="project-angle_input">
                <el-input class="roomsize_input" v-model='hAngleData' :class="{red_out:(!indAngleSwitch && isHAngleOut && hAngleFlagData)||(indAngleSwitch && !isOnCornerAreas && hAngleFlagData)}" :disabled="!hAngleFlagData" @input="testDigitalNegative($event, 'hAngleData')" @blur='changeAngleData("hAngleData", "SET_HANGLE")' @keyup.enter.native='changeAngleData("hAngleData", "SET_HANGLE")'></el-input>
              </div>
              <span class='m'>°</span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div class="ambient_condition">
        <el-collapse v-model="ambient_activeNames">
          <el-collapse-item :title="$t('T_AMBIENT_CONDITION')" name="1">
            <div class='ambient_application'>
              <div class="aspect_ratio">
                <span>{{$t('T_ROOM_TYPE')}}</span>
              </div>
              <div class="ratio-select">
                <el-select v-model='appSelect' @change='changeBrightness'>
                  <el-option v-for='item in application' :key='item.value' :label='$t(item.label)' :value='item.value'>
                  </el-option>
                </el-select>
              </div>
              <div class="clear"></div>
            </div>
          <div class='birghtness'>
            <div class="screen-position">
              <span>{{$t('T_BRIGHTNESS')}}</span>
            </div>
            <div class="screen-position_input_lux">
              <el-input class="roomsize_input" v-model='brightnessData' @input="testDigital($event, 'brightnessData')"></el-input>
              <span class='m'>{{$t('T_LUX')}}</span>
            </div>
          </div>
            <div class='ambient_screengain'>
              <div class="screen-position">
                <span>{{$t('T_SCREENGAIN')}}</span>
              </div>
              <div class="screengain_input">
                <inputValidateBox prop='gainData' :rules="rules.number">
                  <el-input class="roomsize_input" v-model='gainData' @input="testDigital($event, 'gainData')" @blur='changGainMutation()' @keyup.enter.native='changGainMutation()'></el-input>
                </inputValidateBox>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

        <Resultbrightnessguide v-if="isUSTWall"></Resultbrightnessguide>
        <!-- 以下勿删 phase2 要用 -->
        <div v-if="!isUSTWall">
          <el-collapse v-model="out_activeNames">
            <el-collapse-item name="1"  class='out_of_spec_item'>
              <template slot="title">
                <div class='ellipsis out_of_spec_title' :title="$t('T_OUT_OF_SPEC_MODE')">
                  {{$t('T_OUT_OF_SPEC_MODE')}}<i class="waring-icon" v-if="waring_icon"></i>
                </div>
              </template>
              <div class='out_switch'>
                <el-switch v-model='outOfSpec' :width='switch_width' @change="switchchange(outOfSpec)"></el-switch>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <el-dialog :visible.sync="outOfSpecDialogStatus" width="480px" :close-on-click-modal="false" class="out_of_spec_dialog" center>
        <div>
          <p>{{$t('T_OUT_OF_SPEC_MODE_MSG1')}}</p>
          <p>{{$t('T_OUT_OF_SPEC_MODE_MSG2')}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="outOfSpecDialogStatus = false" size="medium">{{$t('T_OK')}}</el-button>
        </span>
      </el-dialog>
      <div class="line">
      </div>
    </el-scrollbar>
  </div>
  <div class="simple_condition" v-else>
    <el-collapse v-model="SettingActiveNames" class="simplt-item" v-show="!DisableN">
      <el-collapse-item name="1">
        <template slot="title">
           <el-image style="width: 18px; height: 18px; margin-right: 5px;" :src="require('@/assets/parts/simple/icon_setting.png')"></el-image>
          {{$t('T_SETTINGS')}}</template>
        <el-row :gutter="10">
          <el-col :span="8">
            <span class="simple-item-title" :title="$t('T_POSITION')">{{$t('T_POSITION')}}</span>
            <div class="simple-item-val">
              <el-select v-model="position" @change="changePosition">
                <el-option :value="0" :label="$t('T_POS_DESKTOP')"></el-option>
                <el-option :value="1" :label="$t('T_POS_CEILING')" :disabled='isCellingDisable'></el-option>
                <el-option :value='2' :label="$t('T_POS_WALL')" :disabled='isWallDisable'></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="8">
            <span class="simple-item-title" :title="$t('T_ASPECT_RATIO')">{{$t('T_ASPECT_RATIO')}}</span>
            <div class="simple-item-val">
              <el-select v-model="aspectRatioData" @change="changeAspectRatio">
                <el-option
                  v-for="item in selectedLensOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="8">
            <span class="simple-item-title" :title="$t('T_SCALE')">{{$t('T_SCALE')}}</span>
            <div class="simple-item-val">
              <el-select v-model="unitData">
                <el-option
                  v-for="item in unitDataOptions"
                  :key="item.value"
                  :label="$t(item.value)"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <div class="simple-mode">
          <div class="simple-mode-title simple-title">{{$t('T_MODE_SIMPLE_UI')}}</div>
          <div class="simple-mode-val">
           <el-select v-model="modeData" @change="getEle">
              <el-option
                v-for="item in modeOptions"
                :key="item.value"
                :label="$t(item.label)"
                :value="item.value"
              ></el-option>
          </el-select>
          </div>
        </div>
        <div class="simple-lens">
          <span class="simple-lens-title simple-title">{{$t('T_LENS_SHIFT_RANGE')}}</span>
          <span class="simple-lens-val">
            <el-switch v-model='lensShiftRangeSwitch' @change="lensShiftChange(lensShiftRangeSwitch)" :width='switch_width' :disabled="simpleUILensShiftDisable"></el-switch>
          </span>
        </div>
        <div class="simple-brightness">
          <span class="simple-lens-title simple-title">{{$t('T_BRIGHTNESS_GUIDE')}}</span>
          <span class="simple-lens-val">
            <el-switch v-model='brightnessGuideSwitch' :width='switch_width'></el-switch>
          </span>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="screen-size-collapse" :class="screenSizeCollapseClass">
      <div class="screensize-collapse" id="screensize" :class="{'icon_none' : DisableN}">
        <el-collapse  @change="screenSizeChange" v-model="screenSizeActive">
          <el-collapse-item name="1" class="param-color-pink">
            <template slot="title">
              <div class="simple-screen-title simple-title" :class="{'set-font-size' : setfontSize}">{{$t('T_SCREEN_SIZE')}}</div>
              <div class='simple-item-val-dwh' :class="{'dwh_bool' : !dwhBool}" v-show="dwhBool || (this.modeData === '1' && !dwhBool)">
                <el-select v-model="dwhSelect" @change="changeDwhSelect">
                  <el-option v-for="item in dwhSelectOptions" :key='item.value' :label='$t(item.label)' :value='item.value'>
                  </el-option>
                </el-select>
              </div>
              <div class="screen-size-dwh item-val-disable" v-if="!dwhBool && this.modeData === '0'" :class="{'set-font-size' : setfontSize}">
                <el-row>
                  <el-col :span="8">
                    <span class="screen-b">
                      <span>{{screenSizeData}}</span>
                      <span class="simple-unit">inch</span>
                    </span>
                  </el-col>
                  <el-col :span="8" class="center">
                    <span class="screen-b">
                      <span class="item-title">W:</span>
                      <span>{{scrnWData}}</span>
                      <span class="simple-unit">{{unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? '' : unitLabel}}</span>
                    </span>
                  </el-col>
                  <el-col :span="8" class="right">
                    <span class="screen-b">
                      <span class="item-title">H:</span>
                      <span>{{scrnHData}}</span>
                      <span class="simple-unit">{{unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? '' : unitLabel}}</span>
                    </span>
                  </el-col>
                </el-row>
              </div>
              <div class="screen-size-dwh p-right" v-else-if="!dwhBool && this.modeData === '1'" :class="{'set-font-size' : setfontSize}">
                {{distanceLockedSizetFormat + ' ~ ' + distanceLockedSizewFormat + ' '}}{{this.dwhSelect === '0' ? 'inch' : unitLabel}}
              </div>
            </template>
            <div class="simple-screensize" :class="{'set-font-size' : setfontSize}" v-show="dwhBool">
              <span class="item">
                <span :class="dwhSelect === '0' ? 'item-val' : 'item-val-disable'">
                  <inputValidateBox prop='screenSizeData' :rules="rules.number" :outVisible="'true'">
                    <el-popover placement="right" trigger="manual" :content="screen_value_out_str" v-model="screen_value_out">
                      <el-input slot="reference" v-model='screenSizeData' class='screensize_input' @input="testDigital($event, 'screenSizeData')" @blur='changeScreenSizeAction' @keyup.enter.native='changeScreenSizeAction' :disabled="dwhSelect === '0' ? false : true"></el-input>
                    </el-popover>
                    <span class="simple-unit">inch</span>
                  </inputValidateBox>
                </span>
              </span>
              <div class="ft_inch-ft-w" :class="dwhSelect === '1' ? 'ft_inch_input' : 'ftitem-val-disable'" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                <span class="ft_inch_item">
                <span class="ft_inch_item-title">W:</span>
                  <FtInput v-model="scrnWData" :unitData="unitData" @blur='changeFtScrnWDataInput' :disabledFlag="dwhSelect === '1' ? false : true"></FtInput>
                </span>
              </div>
              <span class="item center" v-else>
                <span class="item-title">W:</span>
                <span :class="dwhSelect === '1' ? 'item-val' : 'item-val-disable'">
                  <inputValidateBox prop='scrnWData' :rules="rules.number">
                    <el-input v-model='scrnWData' class='screensize_input' @input="testDigital($event, 'scrnWData')"
                      @blur='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")' @keyup.enter.native='changeMutation("scrnWData", "SET_GRAPH_SCRNW", "changeScreenW")' :disabled="dwhSelect === '1' ? false : true"></el-input>
                    <span class="simple-unit">{{unitLabel}}</span>
                  </inputValidateBox>
                </span>
              </span>
              <div class="ft_inch-ft-h" :class="dwhSelect === '2' ? 'ft_inch_input' : 'ftitem-val-disable'" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
                <span class="ft_inch_item">
                <span class="ft_inch_item-title">H:</span>
                  <FtInput v-model="scrnHData" :unitData="unitData" @blur='changeFtScrnHDataInput' :disabledFlag="dwhSelect === '2' ? false : true"></FtInput>
                </span>
              </div>
              <span class="item right" v-else>
                <span class="item-title">H:</span>
                <span :class="dwhSelect === '2' ? 'item-val' : 'item-val-disable'">
                  <inputValidateBox prop='scrnHData' :rules="rules.number">
                    <el-input v-model='scrnHData' class='screensize_input'  @input="testDigital($event, 'scrnHData')"
                      @blur='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")' @keyup.enter.native='changeMutation("scrnHData", "SET_GRAPH_SCRNH", "changeScreenH")' :disabled="dwhSelect === '2' ? false : true"></el-input>
                    <span class="simple-unit">{{unitLabel}}</span>
                  </inputValidateBox>
                </span>
              </span>
            </div>
            <!-- screen size的slider  Basic-->
            <div class="screen-size_sliderbar" v-if="!isOutOfSpec" @mouseenter="mouseOnSize" @mouseleave="mouseOutSize">
              <div class="sld throw_dis_sld" v-show="real_throw_distance_checked">
                <div class="border" ref="throwDisLine"></div>
                <el-slider ref='realThrowDisSliderRangeFlag' v-model="realThrowDisSliderRangeData" :step="0.001" :show-tooltip="false"
                  class="throw_distance_slider pjy-slider simple-screen-slider" :min="0" :max="realThrowDisSliderRangeMax"></el-slider>
                <label class="lab" ref = "distanceLockedSizetFormat" style="position: absolute;top: 10px;">{{distanceLockedSizetFormat}}</label>
                <label class="lab" ref = "distanceLockedSizewFormat" style="position: absolute;top: 45px;">{{distanceLockedSizewFormat}}</label>
              </div>
              <div class="sld screen_size_sld" v-show="!real_throw_distance_checked">
                 <el-slider ref="screenSizeSliderFlag" v-showTip v-model="screenSizeSlider" :step="0.001" :show-tooltip="false" class="throw_distance_slider simple-slider-color-pink" @change="screenChanged" :min="ratioScreenSizeMin" :max="ratioScreenSizeMax"></el-slider>
              </div>
                <label class="lab" style="margin-left:10px">{{diagonalMinFormat}}</label>
                <label class="lab" style="float:right;margin-right:10px">{{diagonalMaxFormat}}</label>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="throw-distance-collapse" id="throwdistance" :class="{'icon_none' : DisableN}">
        <el-collapse @change="throwDistanceChange" v-model="throwActive">
          <el-collapse-item class="param-color-blue" name="1">
            <template slot="title">
              <div class="simple-throw-title simple-title" :class="{'set-font-size' : setfontSize}">{{$t('T_LENS_THROW_DISTANCE')}}</div>
              <div class="simple-lens-title screen-size-dwh">{{'(' + $t('T_SIMPLEUI_LENS_TO_SCREEN') + ')'}}</div>
              <div class="simple-throw-val simple-title" v-show="!throwValBool && this.modeData === '0'">{{throwDisSliderwFormat}}<span v-if="throwDisSliderwFormat!=throwDisSlidertFormat"> ~ {{throwDisSlidertFormat}}</span>{{unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? '' : unitLabel}}</div>
              <div class="simple-throw-val simple-title" v-show="!throwValBool && this.modeData === '1'">{{pjYData + ' '}}{{unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? '' : unitLabel}}</div>
              <div class="ftf_throw-distance ft_inch_input" :class="{'ftf_throw-distance_feet': $i18n.locale === 'sk'}" v-if="throwValBool && (unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION')">
                <FtInput v-model="pjYData" :unitData="unitData" @blur='changeFtThrowDisInput' @click.native.stop></FtInput>
              </div>
              <div class="simple-throw-val-input simple-title" v-show="throwValBool" v-else>
                <!-- <inputValidateBox prop='pjYData' :rules="rules.number"> -->
                  <el-popover placement="right" trigger="manual" :content="pjY_value_out_str" v-model="pjY_value_out">
                    <el-input slot="reference" @click.native.stop class="screensize_input" v-model='pjYData' @input="testDigital($event, 'pjYData')" @blur='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")' @keyup.enter.native='changeMutation("pjYData", "SET_GRAPH_PJY", "changeDistance")'>
                    </el-input>
                  </el-popover>
                  <span class='simple-unit'>{{unitLabel}}</span>
                <!-- </inputValidateBox> -->
              </div>
            </template>
          <!-- throw distance的slider Basic-->
            <div class="condition_sliderbar" v-if="!isOutOfSpec" @mouseenter="mouseOnDis" @mouseleave="mouseOutDis">
              <div class="sld throw_dis_sld" v-if="!real_throw_distance_checked">
                <div class="border" ref="throwDisLine"></div>
                <el-slider ref='throwDisSliderRangeFlag' v-model="throwDisSliderRangeData" @change="throwDisChangedSizeLocked" :show-tooltip="false" :step="0.001" :disabled="!screen_size_checked"
                  class="throw_distance_slider pjy-slider simple-slider-color-blue simple-slider" :min="0" :max="throwDisSli"
                  :style="{left: sliderL + '%'}" :class="screen_size_checked ? 'block':'none'"></el-slider>
                <label class="lab" :style="{left: sliderL - 5 + '%'}" style="position: absolute;top: 10px;">{{throwDisSliderwFormat}}</label>
                <label class="lab" :style="{left: slidertL - 6 + '%'}" style="position: absolute;top: 45px;" v-if="throwDisSliderwFormat != throwDisSlidertFormat">{{throwDisSlidertFormat}}</label>
              </div>
              <div class="sld throw_dis_sld" :class="{'throw_slider' : real_throw_distance_checked, 'check' : !real_throw_distance_checked}">
                <el-slider v-model="throwDisSliderData" v-showTipDis ref="throwDisSliderFlag" @change="throwDisChanged" :disabled="screen_size_checked" :show-tooltip="false" class="throw_distance_slider pjy-slider-T simple-slider-color-blue" :step="0.001" :min="throwDisSliderMin" :max="throwDisSliderMax" :class="screen_size_checked ? 'none':'block'"></el-slider>
              </div>
              <div style="overflow: hidden">
                <label class="lab" style="float:left;margin-top:10px">{{throwDisSliderMinFormat}}</label>
                <label class="lab" style="float:right;margin-top:10px">{{throwDisSliderMaxFormat}}</label>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="distance-from-floor">
        <SimpleItem :title="$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT')" :value='floor2footProjector' :isNegativeNum='isNegativeNum' addClass='param-color-green' v-if="position === 0"></SimpleItem>
        <SimpleItem :title="$t('T_RESULT_FLOOR_TO_UPPER_HEIGHT')" :value='floor2upperProjectorLx' addClass='param-color-green' v-else-if="position !== 0 && this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1"></SimpleItem>
        <SimpleItem :title="$t('T_RESULT_FLOOR_TO_UPPER_HEIGHT')" :value='floor2upperProjector' addClass='param-color-green' v-else></SimpleItem>
        <SimpleItem :title="$t('T_RESULTCEILING_TO_TOP_HEIGHT')" :value='floor2topCpmuted' addClass='param-color-violet'></SimpleItem>
        <SimpleItem :title="$t('T_RESULT_FLOOR_TO_BOTTOM_HEIGHT')" :value='floor2bottomData + " " + (unitData === "T_FEET_FRACTION" || unitData === "T_INCH_FRACTION" ? " " : unitLabel)' addClass='param-color-orange'></SimpleItem>
      </div>
      <div class="lens-shift-range" v-show="lensShiftRangeBool">
        <div class="lens-shift-range-title" :class="{'set-font-size' : setfontSize}">{{$t('T_LENS_SHIFT_RANGE')}}</div>
        <SimpleItem :title="$t('T_UPWARD')" :value='MaxOctagonH + " " + (unitData === "T_FEET_FRACTION" || unitData === "T_INCH_FRACTION" ? " " : unitLabel)' addClass='param-color-black'></SimpleItem>
        <SimpleItem :title="$t('T_HORIZONTAL')" :value='HorizontalW + " " + (unitData === "T_FEET_FRACTION" || unitData === "T_INCH_FRACTION" ? " " : unitLabel)' addClass='param-color-black'></SimpleItem>
        <SimpleItem :title="$t('T_DOWNWARD')" :value='MinOctagonH + " " + (unitData === "T_FEET_FRACTION" || unitData === "T_INCH_FRACTION" ? " " : unitLabel)' addClass='param-color-black'></SimpleItem>
      </div>
    </div>
  </div>
  <div class="ceiling-height" v-if="isSimple">
    <div class="simple-item-clh" :class="{'set-font-size' : setfontSize}">
      <div class="simple-item-clh-box ceiling-height-color"></div>
      <div class="simple-item-clh-title">{{$t('T_CEILING_HEIGHT')}}</div>
      <div class="simple-item-clh-ft-val ft_inch_input" v-if="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION'">
        <FtInput v-model="roomHData" :unitData="unitData" @blur='changeMutation("roomHData", "SET_GRAPH_ROOMH", true)' :forceUpdate='roomHForceUpdate'></FtInput>
      </div>
      <div class="simple-item-clh-val screensize_input" v-else>
        <inputValidateBox prop='roomHData' :rules="rules.number">
          <el-popover placement="right" trigger="manual" :content="roomH_value_out_str" v-model="roomH_value_out">
            <el-input slot="reference" v-model='roomHData' @input="testDigital($event, 'roomHData')" class='roomsize_input'
              @blur='changeMutation("roomHData", "SET_GRAPH_ROOMH", true)'
              @keyup.enter.native='changeMutation("roomHData", "SET_GRAPH_ROOMH", "changeRoomH")'>
            </el-input>
          </el-popover>
          <span class="unit" :class="{'inch-font-size': unitLabel=== 'inch'}">{{unitLabel}}</span>
        </inputValidateBox>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { EventBus } from '@/common/event-bus.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import inputValidateBox from '@/components/inputValidateBox'
import Resultbrightnessguide from '@/view/result/resultBrightnessGuide'
import SimpleItem from '@/view/graph/Simple/simpleItem'
import CurveCondition from './curveCondition'
import FtInput from '@/components/ftInput'

export default {
  name: 'condition',
  data () {
    return {
      activeNames: ['1'],
      angle_activeNames: ['1'],
      ambient_activeNames: ['1'],
      out_activeNames: ['0'],
      curve_activeNames: ['0'],
      switch_width: 58,
      lock_checked: true,
      offsetData: '',
      floor2bottomData: '',
      waring_icon: false,
      aspect: [
        {
          value: '1',
          label: '1'
        }
      ],
      application: [{
        value: '0',
        label: 'T_MEETING_ROOM'
      }, {
        value: '1',
        label: 'T_CLASS_ROOM'
      }, {
        value: '2',
        label: 'T_EVENT_HALL'
      }, {
        value: '3',
        label: 'T_LIVING_ROOM'
      }, {
        value: '4',
        label: 'T_THEATRE_ROOM'
      }, {
        value: '5',
        label: 'T_CUSTOM'
      }],
      appSelect: '0',

      roomWData: '',
      roomHData: '',
      roomDData: '',
      floor2footProjectorData: '',
      pjYData: '',
      scrnWData: '',
      scrnHData: '',
      screenSizeData: '',
      gainData: '',
      vAngleData: '',
      hAngleData: '',
      // position: 0,
      screen_value_out: false,
      screen_value_out_str: '',
      pjY_value_out: false,
      pjY_value_out_str: '',
      roomH_value_out: false,
      roomH_value_out_str: '',
      rules: {
        'number': [
          {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'}
        ],
        'numberValid': [
          {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'},
          {pattern: /^\d+\.\d+$|\\+$|"+$/g, message: 'T_ALERT_DISPLAY_INPUT_ERROR'}
        ],
        'pjYData': [
          {
            validator: this.validatePjYData, trigger: 'blur'
          }
        ]
      },
      outOfSpecDialogStatus: false,
      ustOffsetMaxVal: 10,
      throw_distance_slider: [100, 200],
      // diagonal对角线最大最小值
      diagonalMin: 0,
      diagonalMax: 0,
      diagonalSliderCurrent: 0,
      // throwDisSliderMin: 0,
      // throwDisSliderMax: 0,
      // throwDisSliderw: 0,
      // throwDisSlidert: 0,
      throwDisSliderWidth: 0,
      currentDistData: [],
      dwhSelectOptions: [
        {
          value: '0',
          label: 'T_DIAGONAL'
        }, {
          value: '1',
          label: 'T_WIDTH'
        }, {
          value: '2',
          label: 'T_HEIGHT'
        }
      ],
      dwhSelect: '0',
      dwhData: 0,
      throwdisCurrnet: 0,
      throwDisChangedSizeLockedCurrent: 0,
      modeOptions: [
        {
          value: '0',
          label: 'T_MODE_SCREENSIZE_TO_THROWDISTANCE'
        },
        {
          value: '1',
          label: 'T_MODE_THROWDISTANCE_TO_SCREENSIZE'
        }
      ],
      modeData: '0',
      dwhDataDetailData: 0,
      dwhBool: false,
      realThrowDisSliderRangeMax: 0,
      indAngRemainPoints: null,
      throwValBool: false,
      currentSizeW: 0,
      currentSizet: 0,
      screenSizeCollapseClass: '',
      celingHeightInput: [],
      throwDisInput: [],
      ft_inch_ftinputH: [],
      ft_inch_ftinputW: [],
      ft_inch_ftinputRW: [],
      ft_inch_ftinputRD: [],
      ft_inch_ftinputF2B: [],
      ft_inch_ftinputOffset: [],
      ft_inch_ftinputPJY: [],
      screenSizeMouseOn: false,
      distanceMouseOn: false,
      moveTime: 0,
      shape: [
        {
          value: '0',
          label: 'T_CURVE_VERTICAL_CURVE'
        },
        {
          value: '1',
          label: 'T_CURVE_HORIZONTAL_CURVE'
        }
      ],
      scrnWForceUpdate: false,
      scrnHForceUpdate: false,
      pjYDataForceUpdate: false,
      roomHForceUpdate: false,
      offsetDataForceUpdate: false,
      intFuncStatus: 0,
      boardWData: '0',
      boardHData: '0',
      boardDData: '0',
      isNegativeNum: false
    }
  },

  mounted () {
    this.initData()
    this.screenSizeChange()
    this.throwDistanceChange()
    this.eventBus()
    this.changeMutation('roomHData', 'SET_GRAPH_ROOMH', 'changeRoomH')
    this.changeMutation('roomWData', 'SET_GRAPH_ROOMW', 'changeRoomW')
    this.changeMutation('roomDData', 'SET_GRAPH_ROOMD', 'changeRoomD')
    window.addEventListener('keydown', this.handleKeyDown, false)
    window.addEventListener('keyup', this.handelKeyUp, false)
  },

  filters: {
    filterFeet (value) {
      return value === 'inch' ? 'ft' : value
    }
  },
  methods: {
    eventBus () {
      let _this = this
      EventBus.$on('dwhSelect', (data) => {
        this.dwhSelect = data
        this.changeDwhSelect()
      })
      EventBus.$on('appSelect', (data) => {
        _this.appSelect = data
      })
      EventBus.$on('changePosition', (data) => {
        _this.changePosition(Number(data))
      })
      EventBus.$on('changePositionMethod', (data) => {
        this.changePosition(Number(data))
      })
    },
    /**
     * From screen to lens校验
     */
    validatePjYData (rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('T_ALERT_DISPLAY_INPUT_NEED')))
      } else {
        let {max, min} = this.getPjyRange()
        if (value * 1 > max || value * 1 < min) {
          callback(new Error(min + '~' + max))
        } else {
          callback()
        }
      }
    },

    mouseOnSize () {
      this.screenSizeMouseOn = true
    },
    mouseOutSize () {
      this.screenSizeMouseOn = false
    },
    mouseOnDis () {
      this.distanceMouseOn = true
    },
    mouseOutDis () {
      this.distanceMouseOn = false
    },

    getScreenSizeRange () {
      let min = 0
      let max = 0
      if (this.real_throw_distance_checked) {
        if (this.dwhSelect === '0') {
          min = this.distanceLockedSizetFormat * 1
          max = this.distanceLockedSizewFormat * 1
        } else {
          let screenSizeTele = this.$commonJs.changeUnit(this.distanceLockedSizetFormat, this.graph.unit, true)
          let screenSizeWide = this.$commonJs.changeUnit(this.distanceLockedSizewFormat, this.graph.unit, true)
          if (this.dwhSelect === '1') {
            min = this.$commonViewJs.getScreenSizeByCalX(screenSizeTele, this.aspectRatio).size
            max = this.$commonViewJs.getScreenSizeByCalX(screenSizeWide, this.aspectRatio).size
          } else if (this.dwhSelect === '2') {
            min = this.$commonViewJs.getScreenSizeByCalY(screenSizeTele, this.aspectRatio).size
            max = this.$commonViewJs.getScreenSizeByCalY(screenSizeWide, this.aspectRatio).size
          }
          min = min < this.ratioScreenSizeMin ? this.ratioScreenSizeMin : min
          max = max < min ? min : max
        }
      } else if (this.isOutOfSpec) {
        min = 0
        max = Number.POSITIVE_INFINITY
      } else {
        let maxSize = this.$commonViewJs.getScreenByFromDistWide(this.$commonViewJs.getMaxDisByRoom() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0))
        min = this.ratioScreenSizeMin
        max = maxSize > this.ratioScreenSizeMax ? this.ustScreenSizeMax && this.ratioScreenSizeMax > this.ustScreenSizeMax ? this.ustScreenSizeMax : this.ratioScreenSizeMax : maxSize
        max = (max * 1).toFixed(2)
      }

      return {
        max: max,
        min: min
      }
    },

    getPjyRange () {
      let min = 0
      let max = 0

      if (this.screen_size_checked) {
        min = this.$commonViewJs.getKy() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
        // max = (this.$commonViewJs.getLy() > this.$commonViewJs.getMaxDisByRoom() ? this.$commonViewJs.getMaxDisByRoom() : this.$commonViewJs.getLy()) - this.offset
        max = this.ustThrowDisSlidertMax ? this.ustThrowDisSlidertMax + this.ustLensToFrontPj : this.$commonViewJs.getLy() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      } else if (this.isOutOfSpec) {
        min = 0
        max = Number.POSITIVE_INFINITY
      } else {
        let maxR = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMax)
        min = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMin)
        max = this.$commonViewJs.getMaxDisByRoom() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) > maxR ? maxR : this.$commonViewJs.getMaxDisByRoom() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      }
      min = this.isUSTWall ? min - this.ustLensToFrontPj : min
      max = this.isUSTWall ? max - this.ustLensToFrontPj : max

      min = this.isFraction ? min : this.$commonJs.changeUnit(min, this.graph.unit, false, false)
      max = this.isFraction ? max : this.$commonJs.changeUnit(max, this.graph.unit, false, false)
      return {
        max: max,
        min: min
      }
    },
    getPjyRangeNoChangeUnit () {
      let min = 0
      let max = 0
      if (this.screen_size_checked) {
        let maxR = this.ustThrowDisSlidertMax ? this.ustThrowDisSlidertMax + this.ustLensToFrontPj : this.$commonViewJs.getLy()
        min = this.$commonViewJs.getKy() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
        max = (maxR > this.$commonViewJs.getMaxDisByRoom() ? this.$commonViewJs.getMaxDisByRoom() : maxR) - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      } else {
        let maxR = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMax)
        min = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMin)
        max = this.$commonViewJs.getMaxDisByRoom() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) > maxR ? maxR : this.$commonViewJs.getMaxDisByRoom() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      }
      return {
        max: max,
        min: min
      }
    },

    getRhRange () {
      let min = 200
      let max = 500
      min = this.isFraction ? min : this.$commonJs.changeUnit(min, this.graph.unit, false, false)
      max = this.isFraction ? max : this.$commonJs.changeUnit(max, this.graph.unit, false, false)
      return {
        max: max,
        min: min
      }
    },
    getSimpleRhRange () {
      let min = 200
      let max = 2000
      min = this.isFraction ? min : this.$commonJs.changeUnit(min, this.graph.unit, false, false)
      max = this.isFraction ? max : this.$commonJs.changeUnit(max, this.graph.unit, false, false)
      return {
        max: max,
        min: min
      }
    },
    getUstOffsetRange (val) {
      let min = 0
      let max = 0
      let minVal
      if (this.selectedModelData.modelSeries === 'Bolivia-UST') {
        if (this.graph.pjY - this.ustLensToFrontPj + val < 10.24) {
          minVal = 10.24 - this.graph.pjY + this.ustLensToFrontPj
        }
        min = this.$commonJs.changeUnit(minVal, this.graph.unit, false, true)
      } else {
        min = this.$commonJs.changeUnit(0, this.graph.unit, false, true)
      }
      // ArmLenMax = 0の場合,対象機種Aなので、Wall2ScreenMax = 100mmで終了
      if (this.selectedModelData.ArmLenMax === 0) {
        max = this.$commonJs.changeUnit(10, this.graph.unit, false, true)
      } else {
        max = this.ustOffsetMax
      }
      return {
        max: max,
        min: min
      }
    },
    getBoardRange (type) {
      let min
      let max
      if (type === 'width') {
        min = 0
        max = this.houseInfo.roomW
      } else if (type === 'height') {
        min = 0
        max = this.houseInfo.roomH
      }

      return {
        max: max,
        min: min
      }
    },
    initData () {
      this.roomWData = this.$commonJs.changeUnit(this.roomW, this.graph.unit, false, true)
      this.roomHData = this.$commonJs.changeUnit(this.roomH, this.graph.unit, false, true)
      this.roomDData = this.$commonJs.changeUnit(this.roomD, this.graph.unit, false, true)
      this.boardWData = this.$commonJs.changeUnit(this.boardW, this.graph.unit, false, true)
      this.boardHData = this.$commonJs.changeUnit(this.boardH, this.graph.unit, false, true)
      this.pjYData = this.$commonJs.changeUnit(this.pjY, this.graph.unit)
      this.scrnWData = this.$commonJs.changeUnit(this.scrnW, this.graph.unit)
      this.scrnHData = this.$commonJs.changeUnit(this.scrnH, this.graph.unit)
      this.offsetData = this.$commonJs.changeUnit(this.offset, this.graph.unit)
      this.floor2bottomData = this.$commonJs.changeUnit(this.floor2bottomComputed, this.graph.unit)
      this.floor2footProjectorData = this.floor2footProjectorComputed
      this.gainData = this.gainComputed
      this.vAngleData = this.vAngleDataComputed
      this.hAngleData = this.hAngleDataComputed
      // let defaultDistData = this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData)
      this.SELECTRATIODATA(this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData))
      // this.intFuncStatus=0 ==> インタラクティブ機能 ON
      // this.intFuncStatus=1 ==> インタラクティブ機能 OFF
      // this.intFuncSupport インタラクティブがサポートするかどうか
      if (this.intFuncSupport && this.intFuncStatus === 0) {
        this.diagonalMin = this.selectRatioData.whiteboardSize.min
        this.diagonalMax = this.selectRatioData.whiteboardSize.intOnMax
        this.SET_RATIOSCREENSIZEMIN(this.selectRatioData.whiteboardSize.min)
        this.SET_RATIOSCREENSIZEMAX(this.selectRatioData.whiteboardSize.intOnMax)
      } else if (this.intFuncSupport && this.intFuncStatus === 1) {
        this.diagonalMin = this.selectRatioData.screenSize.wall.min
        this.diagonalMax = this.selectRatioData.screenSize.wall.max
        this.SET_RATIOSCREENSIZEMIN(this.selectRatioData.screenSize.wall.min)
        this.SET_RATIOSCREENSIZEMAX(this.selectRatioData.screenSize.wall.max)
      } else {
        // Position=0  デスクトップの場合
        // Position=1  天吊りの場合
        // Position=2  壁掛けの場合
        if (this.Position === 2) {
          this.diagonalMin = this.selectRatioData.screenSize.wall.min
          this.diagonalMax = this.selectRatioData.screenSize.wall.max
          this.SET_RATIOSCREENSIZEMIN(this.selectRatioData.screenSize.wall.min)
          this.SET_RATIOSCREENSIZEMAX(this.selectRatioData.screenSize.wall.max)
        } else {
          this.diagonalMin = this.selectRatioData.screenSize.w.min
          this.diagonalMax = this.selectRatioData.screenSize.w.max
          this.SET_RATIOSCREENSIZEMIN(this.selectRatioData.screenSize.w.min)
          this.SET_RATIOSCREENSIZEMAX(this.selectRatioData.screenSize.w.max)
        }
      }
      this.changeDiagonal()
      this.screenSizeData = this.screenSizeDataComputed
      this.changeScreenSize()
      this.dwhData = this.screenSizeData
      this.curve_depth = this.$commonJs.changeUnit(this.curveDepth, this.graph.unit, false, true)
    },

    throwDisChangedSizeLocked () {
      this.throwDisChangedSizeLockedCurrent = this.$commonViewJs.getKy() + this.throwDisSliderRangeData - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      this.SET_GRAPH_PJY(this.throwDisChangedSizeLockedCurrent)
      this.changeSliderDistance()
    },

    throwDisChanged () {
      this.SET_GRAPH_PJY(this.throwdisCurrnet)
      this.changeSliderDistance()
    },

    screenChanged () {
      this.screenSizeData = this.diagonalSliderCurrent
      this.changeScreenSize()
    },

    changeftMutation (key, ftmutationKey, callBack, args = '') {
      var temp = this.$commonJs.changeUnit(this[key], this.graph.unit, true)
      this[key] = this.$commonJs.changeUnit(temp, this.graph.unit, false)
      this[ftmutationKey](temp)
      if (typeof this[callBack] === 'function') {
        this[callBack](args)
      }
    },
    initForceUpdateValue () {
      this.pjYDataForceUpdate = false
      this.scrnWForceUpdate = false
      this.scrnHForceUpdate = false
      this.roomHForceUpdate = false
      this.offsetDataForceUpdate = false
    },

    changeMutation (key, mutationKey, callBack, args = '') {
      if (!this.isFraction && (isNaN(this[key]) || this[key] === '')) this[key] = '0'
      if (key === 'pjYData') {
        let temp = this[key]
        let {max, min} = this.getPjyRange()
        let value = this.isFraction ? this.$commonJs.changeUnit(this[key], this.graph.unit, true) : this[key]
        this[key] = this.isFraction ? this.$commonJs.changeUnit(this.$commonJs.checkRange(value, min, max), this.graph.unit, false) : this.$commonJs.checkRange(value, min, max)
        if (this.isFraction) {
          this.pjYDataForceUpdate = true
        }
        if (temp !== this[key]) {
          this.PjyShowRangeError('pjY_value_out', 'pjY_value_out_str', min + '~' + max)
        }
      }
      if (key === 'scrnWData') {
        let s = this.getScreenSizeRange()
        let size = this.$commonViewJs.getScreenSizeByCalX(this.$commonJs.changeUnit(this[key], this.graph.unit, true), this.aspectRatio)
        size = this.$commonJs.checkRange(size.size, s.min, s.max)
        let d = this.$commonViewJs.getScreenXYByScreenSize(size, this.aspectRatio).calX
        this[key] = this.$commonJs.changeUnit(d, this.graph.unit, false)
        if (this.isFraction) {
          this.scrnWForceUpdate = true
        }
      }
      if (key === 'scrnHData') {
        let s = this.getScreenSizeRange()
        let size = this.$commonViewJs.getScreenSizeByCalY(this.$commonJs.changeUnit(this[key], this.graph.unit, true), this.aspectRatio)
        size = this.$commonJs.checkRange(size.size, s.min, s.max)
        let d = this.$commonViewJs.getScreenXYByScreenSize(size, this.aspectRatio).calY
        this[key] = this.$commonJs.changeUnit(d, this.graph.unit, false)
        if (this.isFraction) {
          this.scrnHForceUpdate = true
        }
      }
      if (this.isUSTWall) {
        if (key === 'roomHData') {
          let temp = this[key]
          let {max, min} = this.getRhRange()
          let value = this.isFraction ? this.$commonJs.changeUnit(this[key], this.graph.unit, true) : this[key]
          this[key] = this.isFraction ? this.$commonJs.changeUnit(this.$commonJs.checkRange(value, min, max), this.graph.unit, false) : this.$commonJs.checkRange(value, min, max)
          if (temp !== this[key]) {
            this.RhShowRangeError('roomH_value_out', 'roomH_value_out_str', min + '~' + max)
          }
          if (this.isFraction && temp !== this[key]) {
            this.roomHForceUpdate = true
          }
        }
        if (key === 'offsetData') {
          let temp = this.$commonJs.changeUnit(this.offsetData, this.graph.unit, true)
          let {max, min} = this.getUstOffsetRange(temp)
          this[key] = this.$commonJs.checkRange(this[key], min, max)
        }
      }
      if (key === 'offsetData' && !this.isUSTWall) {
        let temp = this.$commonJs.changeUnit(this.offsetData, this.graph.unit, true)
        if (temp > this.houseInfo.roomD) {
          this[key] = this.$commonJs.changeUnit(this.houseInfo.roomD, this.graph.unit, false)
          if (this.isFraction && temp !== this[key]) {
            this.offsetDataForceUpdate = true
          }
        }
      }
      if (this.isSimple) {
        if (key === 'roomHData') {
          let temp = this[key]
          let {max, min} = this.getSimpleRhRange()
          let value = this.isFraction ? this.$commonJs.changeUnit(this[key], this.graph.unit, true) : this[key]
          this[key] = this.isFraction ? this.$commonJs.changeUnit(this.$commonJs.checkRange(value, min, max), this.graph.unit, false) : this.$commonJs.checkRange(value, min, max)

          if (temp !== this[key]) {
            this.RhShowRangeError('roomH_value_out', 'roomH_value_out_str', min + '~' + max)
          }
          if (this.isFraction && temp !== this[key]) {
            this.roomHForceUpdate = true
          }
        }
      }
      if (key === 'boardWData') {
        let s = this.getBoardRange('width')
        let tmp = this.$commonJs.changeUnit(this[key], this.graph.unit, true)
        tmp = this.$commonJs.checkRange(tmp, s.min, s.max)
        this[key] = this.$commonJs.changeUnit(tmp, this.graph.unit, false)
      }
      if (key === 'boardHData') {
        let s = this.getBoardRange('height')
        let tmp = this.$commonJs.changeUnit(this[key], this.graph.unit, true)
        tmp = this.$commonJs.checkRange(tmp, s.min, s.max)
        this[key] = this.$commonJs.changeUnit(tmp, this.graph.unit, false)
      }
      if (key === 'boardDData') {
        let tmp = this.$commonJs.changeUnit(this[key], this.graph.unit, true)
        tmp = this.$commonJs.checkRange(tmp, 0, 10)
        this[key] = this.$commonJs.changeUnit(tmp, this.graph.unit, false)
      }
      var temp = this.$commonJs.changeUnit(this[key], this.graph.unit, true)
      this[key] = this.$commonJs.changeUnit(temp, this.graph.unit, false)
      if (key === 'pjYData') {
        temp = this.isUSTWall ? temp + this.ustLensToFrontPj : temp
      }
      this[mutationKey](temp)
      if (typeof this[callBack] === 'function') {
        this[callBack](args)
      }

      if (this.isOutOfSpec) {
        switch (key) {
          case 'roomDData':
            if (this[key] * 1 < this.pjYData * 1) {
              this.SET_GRAPH_PJY(temp - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0))
            }
            break
          case 'pjYData':
            if (temp > this.roomD) {
              this.SET_GRAPH_ROOMD(temp + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0))
            }
            break
          default:
            break
        }
      }
      this.$nextTick(() => {
        this.initForceUpdateValue()
      })
    },

    changeFtCelingHeightInput (val) {
      let MinVal = 200
      let MaxVal = 2000
      let AllValUnit = this.$commonJs.changeUnit(val, this.graph.unit, true)
      if (AllValUnit < MinVal) {
        this.SET_GRAPH_ROOMH(MinVal)
      } else if (AllValUnit > MaxVal) {
        this.SET_GRAPH_ROOMH(MaxVal)
      } else {
        this.SET_GRAPH_ROOMH(AllValUnit)
      }
      this.changeRoomH()
    },

    changeFtThrowDisInput (val) {
      let {max, min} = this.getPjyRange()
      let temp = this.$commonJs.changeUnit(val, this.graph.unit, true)
      this.pjYData = this.$commonJs.checkRange(temp, min, max)
      this.SET_GRAPH_PJY(this.pjYData)
      this.changeDistance()
    },

    changeFtPjyDataInput (val) {
      this.SET_GRAPH_PJY(this.$commonJs.changeUnit(val, this.graph.unit, true))
    },

    changeFtFloor2bottomDataInput (val) {
      this.SET_FLOOR2BOTTOM(this.$commonJs.changeUnit(val, this.graph.unit, true))
    },

    changeFtScrnHDataInput (val) {
      this.SET_GRAPH_SCRNH(this.$commonJs.changeUnit(val, this.graph.unit, true))
      this.changeScreenH()
    },

    changeFtScrnWDataInput (val) {
      this.SET_GRAPH_SCRNW(this.$commonJs.changeUnit(val, this.graph.unit, true))
      this.changeScreenW()
    },

    changeFtRoomDDataInput (val) {
      this.SET_GRAPH_ROOMD(this.$commonJs.changeUnit(val, this.graph.unit, true))
    },

    changeFtRoomWDataInput (val) {
      this.SET_GRAPH_ROOMW(this.$commonJs.changeUnit(val, this.graph.unit, true))
      this.changeRoomW()
    },

    changeFtOffsetInput (val) {
      this.SET_OFFSET(this.$commonJs.changeUnit(val, this.graph.unit, true))
      // let temp = this.$commonJs.changeUnit(val, this.graph.unit, true)
      // if (temp > this.houseInfo.roomD) {
      //   this.SET_OFFSET(this.houseInfo.roomD)
      //   this.offsetData = this.$commonJs.changeUnit(this.houseInfo.roomD, this.graph.unit)
      // } else {
      //   this.SET_OFFSET(temp)
      // }
    },

    changeFtRoomHInput (val) {
      let MinVal = 200
      let MaxVal = 2000
      let AllValUnit = this.$commonJs.changeUnit(val, this.graph.unit, true)
      if (AllValUnit < MinVal) {
        this.SET_GRAPH_ROOMH(MinVal)
      } else if (AllValUnit > MaxVal) {
        this.SET_GRAPH_ROOMH(MaxVal)
      } else {
        this.SET_GRAPH_ROOMH(AllValUnit)
      }
      this.changeRoomH()
    },

    /**
     * 在修改房间大小时，设置投影仪不出房间
     */
    changeRoomH () {
      if (this.graph.pjZ < this.limitData) {
        this.PJZ(this.limitData)
      } else if (this.graph.pjZ > this.houseInfo.roomH - this.limitData) {
        this.PJZ(this.houseInfo.roomH - this.limitData)
      }
    },

    changeRoomW () {
      if (this.graph.pjX < this.limitData) {
        this.PJX(this.limitData)
      } else if (this.graph.pjX > this.houseInfo.roomW - this.limitData) {
        this.PJX(this.houseInfo.roomW - this.limitData)
      }
    },

    changGainMutation () {
      if (isNaN(this.gainData)) this.gainData = '0.0'
      this.gainData = (this.gainData * 1).toFixed(1)
      this['SET_GAIN'](this.gainData)
    },

    // 改变floor2bottom，要改变pjz，但是不能再watch的时候改
    changeFloorMutation () {
      if (!this.floor_footProjector_checked) {
        if (!this.isFraction && isNaN(this.floor2bottomData)) this.floor2bottomData = '0'
        var temp = this.$commonJs.changeUnit(this.floor2bottomData, this.graph.unit, true)
        if (temp < this.limitData) {
          temp = this.limitData
        }
        this.floor2bottomData = this.$commonJs.changeUnit(temp, this.graph.unit)
        let temoPjz = this.graph.pjZ - (temp - this.floor2bottom)
        let limit = -this.$commonViewJs.getMaxOutRoomH(this.initScreenSize.h) + this.limitData
        if (temoPjz < limit) {
          temoPjz = limit
        }
        this.PJZ(temoPjz)
        this.SET_FLOOR2BOTTOM(temp)
      } else {
        let projectorCenterToBottom = this.houseInfo.roomH - this.$commonViewJs.getAz()
        let temp = this.$commonJs.changeUnit(this.floor2bottomData, this.graph.unit, true)
        let {max, min} = this.getPjyRange()
        let pjYNewData = ((Number(this.graph.pjY) / 100)) / (projectorCenterToBottom - Number(this.floor2bottom)) * (projectorCenterToBottom - Number(temp))
        let value = pjYNewData
        pjYNewData = this.$commonJs.checkRange(value, min, max)
        this.floor2bottomData = this.$commonJs.changeUnit(this.floor2bottom, this.graph.unit)
        this.PJY((pjYNewData * 100))
      }
    },
    changeFloor2footProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let temoPjz
      if (this.selectedModelData.lensExchange === true) {
        temoPjz = this.houseInfo.roomH - this.$commonJs.changeUnit(this.floor2footProjectorData, this.graph.unit, true) - BrightnessDataFe
      } else {
        if (this.$commonJs.changeUnit(this.floor2footProjectorData, this.graph.unit, true) > (this.houseInfo.roomH - this.selectedLensData.fe)) {
          this.floor2footProjectorData = this.$commonJs.changeUnit(this.houseInfo.roomH - this.selectedLensData.fe, this.graph.unit, false)
        }
        temoPjz = this.houseInfo.roomH - this.$commonJs.changeUnit(this.floor2footProjectorData, this.graph.unit, true) - this.selectedLensData.fe
      }
      this.PJZ(temoPjz)
    },

    // 改距离，影响宽,高,对角线
    changeDistance () {
      if (this.screen_size_checked) {
        this.checkIsElectron()
        return
      }
      if (this.throw_distance_checked) {
        this.changeDistanceOnThrowDisLocked()
      } else {
        // let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        // this.changePjy(this.graph.pjY)
        let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        this.checkScreenSize(result)
      }
    },

    // 改距离，影响宽,高,对角线
    changeSliderDistance () {
      if (this.screen_size_checked) {
        this.checkIsElectron()
        return
      }
      if (this.throw_distance_checked) {
        this.changeDistanceOnThrowDisLocked()
      } else {
        this.changePjy(this.graph.pjY)
      }
    },

    checkIsElectron () {
      let flag = 1
      if (this.position !== 0) {
        flag = -1
      }
      let defaultDistInfo = this.selectRatioData
      let vlensShiftN
      // 计算当当前投影仪不为超短焦，并且为电子变焦时
      if (this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) {
        if (this.screen_size_checked) {
          let wSize = this.$commonViewJs.getScreenSizeFromDist(this.graph.pjY)
          let wSizeInch = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
          let l = (wSize.calY - this.graph.scrnH) / 2
          let v2 = defaultDistInfo.wv.wv2 * wSizeInch
          let v2l = v2 - l
          vlensShiftN = (v2l - this.graph.scrnH / 2) / this.initScreenSize.h * flag
        } else {
          vlensShiftN = (defaultDistInfo.wv.wv2 * this.screenSize - this.graph.scrnH / 2) / this.initScreenSize.h * flag
        }
      } else if (this.selectedModelData.category === 4) {
        let selectedLensData = this.selectedLensData

        if (this.screen_size_checked) {
          let wSize = this.$commonViewJs.getScreenSizeFromDist(this.graph.pjY)
          let wSizeInch = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
          let v1b = wSizeInch * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
          let l = (wSize.calY - this.graph.scrnH) / 2
          vlensShiftN = (wSize.calY / 2 + v1b - selectedLensData.mu - l) / this.initScreenSize.h * flag
        } else {
          let v1b = this.screenSize * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
          vlensShiftN = (this.graph.scrnH / 2 + v1b - selectedLensData.mu) / this.initScreenSize.h * flag
        }
      }
      if (vlensShiftN) {
        this.SET_VLENSSHIFT(vlensShiftN * 100)
        let vals = {}
        vals.max = vlensShiftN
        vals.min = vlensShiftN
        this.VLENSSHIFT(vals)
        let ll = {}
        ll.max = vlensShiftN * flag
        ll.min = vlensShiftN * flag
        this.SET_TEMVLENSSHIFT(ll)
      }
      if (this.isUSTWall && this.screenSizeChecked && this.throwDistanceChecked) {
        this.PJZ(this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * vlensShiftN))
      }
    },
    // ThrowDistance改距离，影响宽,高,对角线
    changeDistanceOnThrowDisLocked () {
      let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
      this.checkScreenSize(result)
      let screenSi = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
      let flToB = this.whiteboardSupport && this.whiteboardStatus ? this.floor2bottom + this.screenBottom2board : this.flToB
      this.PJZ(this.houseInfo.roomH - (flToB + screenSi.calY / 2 - screenSi.calY * this.vLensShiftNow / 100))
      this.PJX(this.flToL + screenSi.calX / 2 - screenSi.calX * this.hLensShiftNow / 100)
    },

    changePjy (pjy) {
      let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
      this.SET_SCREENSIZE(result)
      // this.throwDisSliderw = this.$commonViewJs.getKy()
      // this.throwDisSlidert = this.$commonViewJs.getLy()
      this.SET_THROWDISSLIDERW(this.$commonViewJs.getKy())
      this.SET_THROWDISSLIDERT(this.$commonViewJs.getLy())
      if (this.ustThrowDisSlidertMax) {
        this.throwDisSlidert = this.ustThrowDisSlidertMax + this.ustLensToFrontPj
        if (this.throwDisSliderw > this.throwDisSlidert) this.throwDisSlidert = this.throwDisSliderw
      }
    },

    checkScreenSize (screenSize) {
      if (this.whiteboardSupport && this.whiteboardStatus && this.boardW > this.houseInfo.roomW) {
        this.boardWData = this.$commonJs.changeUnit(this.houseInfo.roomW, this.graph.unit, false)
        this.changeMutation('boardWData', 'BOARDW', 'changeDwhSelect')
      } else if (this.whiteboardSupport && this.whiteboardStatus && this.boardH > this.houseInfo.roomH) {
        this.boardHData = this.$commonJs.changeUnit(this.houseInfo.roomH, this.graph.unit, false)
        this.changeMutation('boardHData', 'BOARDH', 'changeDwhSelect')
      }
      let {max, min} = this.getScreenSizeRange()
      screenSize = this.$commonJs.checkRange(screenSize, min, max)
      this.SET_SCREENSIZE(screenSize)
      if (!this.real_throw_distance_checked) {
        let distance = this.$commonViewJs.calScreensizeToDistanceWide(screenSize)
        this.SET_GRAPH_PJY(distance)
        this.resetScreenByPjy()
        if (distance >= this.roomD) {
          this.SET_GRAPH_ROOMD(distance)
        }
        this.SET_THROWDISSLIDERW(this.$commonViewJs.getKy())
        this.SET_THROWDISSLIDERT(this.$commonViewJs.getLy())
        // this.throwDisSliderw = this.$commonViewJs.getKy()
        // this.throwDisSlidert = this.$commonViewJs.getLy()
        if (this.ustThrowDisSlidertMax) {
          this.throwDisSlidert = this.ustThrowDisSlidertMax + this.ustLensToFrontPj
          if (this.throwDisSliderw > this.throwDisSlidert) this.throwDisSlidert = this.throwDisSliderw
        }
      }
    },
    // 改变对角线，影响距离 ==> 宽高
    changeScreenSize () {
      if (isNaN(this.screenSizeData)) this.screenSizeData = '0'
      let tempCopy = this.screenSizeData
      let {max, min} = this.getScreenSizeRange()
      this.screenSizeData = this.$commonJs.checkRange(this.screenSizeData, min, max)
      if (tempCopy !== this.screenSizeData) {
        this.PjyShowRangeError('screen_value_out', 'screen_value_out_str', min + '~' + max)
      }
      this.SET_SCREENSIZE(this.screenSizeData)
      let wh = this.$commonViewJs.getScreenXYByScreenSize(this.screenSizeData, this.aspectRatio)
      this.SCRNW(wh.calX)
      this.SCRNH(wh.calY)
      // this.dwhDataDetailData = this.screenSizeData
      this.dwhData = this.screenSizeData
      if (!this.real_throw_distance_checked) {
        let distance = this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize)
        this.SET_GRAPH_PJY(distance)
        if (this.isOutOfSpec && distance >= this.roomD) {
          this.SET_GRAPH_ROOMD(distance)
        }
      }
      // var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
      // this.SET_INITSCREENSIZEW(initScreen.calX)
      // this.SET_INITSCREENSIZEH(initScreen.calY)
      // let result = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
      // this.SET_GRAPH_SCRNW(result.calX)
      // this.SET_GRAPH_SCRNH(result.calY)
      this.isPositionChecked()
    },

    changeScreenSizeAction () {
      this.changeScreenSize()
      if (this.isSimple && this.modeData === '0') {
        this.SET_SCREENSIZECHECKED(true)
        this.resetScreenByPjy()
      }
    },

    checkScreenSizeNoPjy (screenSize) {
      // let {max, min} = this.getScreenSizeRange()

      // this.screenSizeData - screenSizeTele
      // console.log(this.screenSizeData)
      // console.log(screenSizeTele)
      // console.log('------------------------------')
      // console.log(screenSize)
      let screenSizeTele = this.$commonViewJs.getScreenByFromDistTele(this.graph.pjY)
      let screenSizeWele = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
      if (screenSizeTele < this.ratioScreenSizeMin) screenSizeTele = this.ratioScreenSizeMin
      if (this.ustScreenSizeMax) screenSizeWele = this.ustScreenSizeMax
      screenSize = this.$commonJs.checkRange(screenSize, screenSizeTele, screenSizeWele)
      this.SET_SCREENSIZE(screenSize)
      // this.screenSizeData = screenSize.toFixed(2)
      let wh = this.$commonViewJs.getScreenXYByScreenSize(screenSize, this.aspectRatio)
      this.SCRNW(wh.calX)
      this.SCRNH(wh.calY)
      let initXY = this.$commonViewJs.getInitScreenXyFromDist(this.$commonViewJs.getKy() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0))
      this.SET_INITSCREENSIZEW(initXY.calX)
      this.SET_INITSCREENSIZEH(initXY.calY)

      if (this.throwDistanceChecked) {
        let flToB = this.whiteboardSupport && this.whiteboardStatus ? this.floor2bottom + this.screenBottom2board : this.flToB
        this.PJZ(this.houseInfo.roomH - (flToB + initXY.calY / 2 - initXY.calY * this.vLensShiftNow / 100))
        this.PJX(this.flToL + initXY.calX / 2 - initXY.calX * this.hLensShiftNow / 100)
      }
      // ==========================================================================================================================================
      // var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
      //   this.SET_INITSCREENSIZEW(initScreen.calX)
      //   this.SET_INITSCREENSIZEH(initScreen.calY)
      //   this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY))
      //   let screen = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
      //   this.SCRNW(screen.calX)
      //   this.SCRNH(screen.calY)
    },

    // 当screenSize锁定时，切换镜头或者投影仪
    changeDistanceOnSizeLocked () {
      this.screenSizeData = (this.screenSize * 1).toFixed(2)

      // 当screenSize锁定时，切换投影仪或者镜头，如果当前尺寸小于当前投影仪的最小尺寸，则切换成最小尺寸
      // let defaultRatio = this.selectedLensData.lcd.aspectRatio
      // let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(defaultRatio, this.selectedLensData)
      // if (Number(this.screenSizeData) < defaultDistInfo.screenSize.w.min) {
      //   this.screenSizeData = defaultDistInfo.screenSize.w.min
      // }
      // if (Number(this.screenSizeData) > defaultDistInfo.screenSize.w.max) {
      //   this.screenSizeData = defaultDistInfo.screenSize.w.max
      // }
      this.checkScreenSize(this.screenSizeData)
      this.changeScreenSize()
    },

    // 改变宽，影响高, 对角线 ==> 距离
    changeScreenW () {
      // 高
      let tempArray = this.aspectRatioData.split(':')
      // this.SET_GRAPH_SCRNH(this.graph.scrnW * tempArray[1] / tempArray[0])
      // 对角线
      let screenSize = Math.sqrt(Math.pow(this.graph.scrnW, 2) + Math.pow(this.graph.scrnW * tempArray[1] / tempArray[0], 2)) / 2.54
      this.checkScreenSize(screenSize)
      this.isPositionChecked()
    },

    // 改变高，影响宽, 对角线 ==> 距离
    changeScreenH () {
      // 宽
      let tempArray = this.aspectRatioData.split(':')
      // this.SET_GRAPH_SCRNW(this.graph.scrnH * tempArray[0] / tempArray[1])
      // 对角线
      let screenSize = Math.sqrt(Math.pow(this.graph.scrnH, 2) + Math.pow(this.graph.scrnH * tempArray[0] / tempArray[1], 2)) / 2.54
      this.checkScreenSize(screenSize)
      this.isPositionChecked()
    },

    // 在改变投影仪的房间信息时，判断position是否选中
    isPositionChecked () {
      if (this.throw_distance_checked) {
        var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
        let flToB = this.whiteboardSupport && this.whiteboardStatus ? this.floor2bottom + this.screenBottom2board : this.flToB
        this.PJZ(this.houseInfo.roomH - (flToB + initScreen.calY / 2 - initScreen.calY * this.vLensShiftNow / 100))
        this.PJX(this.flToL + initScreen.calX / 2 - initScreen.calX * this.hLensShiftNow / 100)
      }
    },

    changeDwhSelect () {
      let defaultDistData = this.selectRatioData
      this.currentDistData = defaultDistData.throwRange.w
      let screenMin
      let screenMax
      // this.intFuncStatus=0 ==> インタラクティブ機能 ON
      // this.intFuncStatus=1 ==> インタラクティブ機能 OFF
      // this.intFuncSupport インタラクティブがサポートするかどうか
      if (this.whiteboardSupport && this.whiteboardStatus) {
        let screen = this.getBoardScreen()
        screenMin = screen.min
        screenMax = screen.max
      } else if (this.intFuncSupport && this.intFuncStatus === 0) {
        screenMin = defaultDistData.whiteboardSize.min
        screenMax = defaultDistData.whiteboardSize.intOnMax
      } else if (this.intFuncSupport && this.intFuncStatus === 1) {
        screenMin = defaultDistData.screenSize.wall.min
        screenMax = defaultDistData.screenSize.wall.max
      } else {
      // Position=0  デスクトップの場合
      // Position=1  天吊りの場合
      // Position=2  壁掛けの場合
        if (this.Position === 2) {
          screenMin = defaultDistData.screenSize.wall.min
          screenMax = defaultDistData.screenSize.wall.max
        } else {
          screenMin = defaultDistData.screenSize.w.min
          screenMax = defaultDistData.screenSize.w.max
        }
      }
      this.SET_RATIOSCREENSIZEMIN(screenMin)
      this.SET_RATIOSCREENSIZEMAX(screenMax)
      if (((this.whiteboardSupport && this.whiteboardStatus) || (this.intFuncSupport && this.intFuncStatus === 0)) && (screenMin > this.screenSizeData || screenMax < this.screenSizeData)) {
        this.screenSizeData = this.$commonJs.checkRange(this.screenSizeData, screenMin, screenMax)
        this.scrnWData = this.$commonJs.changeUnit(this.$commonViewJs.getScreenXYByScreenSize(this.screenSizeData, this.aspectRatio).calX, this.graph.unit, false)
        this.scrnHData = this.$commonJs.changeUnit(this.$commonViewJs.getScreenXYByScreenSize(this.screenSizeData, this.aspectRatio).calY, this.graph.unit, false)
        this.changeScreenSize()
      }
      if (this.dwhSelect === '0') {
        this.dwhData = parseFloat((this.screenSizeData)).toFixed(2)
        this.diagonalMin = screenMin
        this.diagonalMax = screenMax
      } else if (this.dwhSelect === '1') {
        this.dwhData = this.graph.scrnW
        this.diagonalMin = parseFloat(this.$commonViewJs.getScreenXYByScreenSize(screenMin, this.aspectRatio).calX)
        this.diagonalMax = parseFloat(this.$commonViewJs.getScreenXYByScreenSize(screenMax, this.aspectRatio).calX)
      } else if (this.dwhSelect === '2') {
        this.dwhData = this.graph.scrnH
        this.diagonalMin = parseFloat(this.$commonViewJs.getScreenXYByScreenSize(screenMin, this.aspectRatio).calY)
        this.diagonalMax = parseFloat(this.$commonViewJs.getScreenXYByScreenSize(screenMax, this.aspectRatio).calY)
      }
    },
    getBoardScreen () {
      let ratio = this.selectRatioData.ratio.split(':')
      let widthMax = this.graph.boardW - 2 * this.board2screenW
      let screenSizeMin = this.selectRatioData.whiteboardSize.min
      let heightMax
      let screenSizeMax
      let widthChecked = false
      let heightChecked = false
      let screenWChecked = false
      let screenHChecked = false
      if (this.fingerTouchStatus && this.FTULocationState) {
        heightMax = this.graph.boardH - this.FTUT2screenT - this.board2screenH
      } else {
        heightMax = this.graph.boardH - 2 * this.board2screenH
      }
      if ((this.intFuncSupport && this.intFuncStatus === 0) || this.fingerTouchStatus) {
        screenSizeMax = this.selectRatioData.whiteboardSize.intOnMax
      } else {
        screenSizeMax = this.selectRatioData.whiteboardSize.intOffMax
      }
      if (widthMax / ratio[0] * ratio[1] <= heightMax) {
        heightChecked = true
      }
      let screenWsize = Math.sqrt(Math.pow(widthMax, 2) + Math.pow(widthMax / ratio[0] * ratio[1], 2)) / 2.54
      if (screenSizeMin <= screenWsize && screenWsize <= screenSizeMax) {
        screenWChecked = true
      }
      if (heightMax / ratio[1] * ratio[0] <= widthMax) {
        widthChecked = true
      }
      let screenHsize = Math.sqrt(Math.pow(heightMax, 2) + Math.pow(heightMax / ratio[1] * ratio[0], 2)) / 2.54
      if (screenSizeMin <= screenHsize && screenHsize <= screenSizeMax) {
        screenHChecked = true
      }
      if (heightChecked && screenWChecked) {
        screenSizeMax = screenWsize.toFixed(2) * 1
      } else if (widthChecked && screenHChecked) {
        screenSizeMax = screenHsize.toFixed(2) * 1
      }
      if (screenSizeMin > screenSizeMax) {
        screenSizeMin = screenSizeMax
        this.SET_THROWERROR(true)
      } else if ((!heightChecked && widthChecked && !screenHChecked && screenSizeMin > screenHsize) ||
        (heightChecked && !screenWChecked && screenSizeMin > screenWsize)) {
        this.SET_THROWERROR(true)
      } else {
        this.SET_THROWERROR(false)
      }
      return {
        min: screenSizeMin,
        max: screenSizeMax
      }
    },

    // 改变比率，距离不变 ==> 影响宽,高,对角线
    changeAspectRatio (value) {
      this.selectedLensData_lcd_distInfo.forEach((item) => {
        if (item.ratio === value) {
          this.F_S2D(item.size2dist)
          this.F_D2S(item.dist2size)
        }
        if (this.screen_size_checked) {
          let distance = this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize)
          this.SET_GRAPH_PJY(distance)
          this.SET_BLACKSIZE(this.$commonViewJs.calDistanceInitToScreensizeWide(distance))
          var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
          this.SET_INITSCREENSIZEW(initScreen.calX)
          this.SET_INITSCREENSIZEH(initScreen.calY)
          if (this.throw_distance_checked) {
            this.PJX(this.flToL + this.initScreenSize.w / 2 - this.initScreenSize.w * this.hLensShiftNow / 100)
            this.PJZ(this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * this.vLensShiftNow / 100))
          }
        }
      })
      this.SELECTRATIODATA(this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData))
    },

    changeBrightness (value) {
      var temp
      if (value === '0') {
        temp = 140
      } else if (value === '1') {
        temp = 210
      } else if (value === '2') {
        temp = 140
      } else if (value === '3') {
        temp = 70
      } else if (value === '4') {
        temp = 14
      } else if (value === '5') {
        temp = 210
      }
      this['SET_APPLICATION'](value)
      this['SET_BRIGHTNESS'](temp)
    },

    testDigital (e, key) {
      e = e.replace(/[^0-9|.]/ig, '')
      let n = (this[key].split('.') || []).length - 1
      if (n > 1) {
        e = ''
      }
      this[key] = e
    },

    testDigitalNegative (e, key) {
      // e = e.replace(/[^(\-|+)0-9|.]/ig, '')
      // if (e !== '-') {
      //   this[key] = e || '0'
      // } else {
      //   this[key] = e
      // }
      this[key] = e
    },

    switchchange (data) {
      data === true ? this.waring_icon = true : this.waring_icon = false
      if (data) {
        this.outOfSpecDialogStatus = true
      }
    },

    changeAngle (key, commit) {
      // 两个投影仪倾斜角度同时打开时（勿删）
      if (this[key] && !this.indAngleSwitch) {
        this[commit](!this[key])
      }
      if (key === 'vAngleFlagData' && isNaN(this.vAngleData)) {
        this.vAngleData = '0'
        this.changeAngleData('vAngleData', 'SET_VANGLE')
      } else if (key === 'hAngleFlagData' && isNaN(this.hAngleData)) {
        this.hAngleData = '0'
        this.changeAngleData('hAngleData', 'SET_HANGLE')
      }
    },

    changeAngleData (key, commit) {
      if (this[key] === '') {
        this[key] = '0'
      }
      if (this[key]) {
        this[key] = (this[key] * 1).toFixed(1)
        this[commit](this[key] * 1)
      }
    },

    changePosition (value) {
      // 20210224至急对应 simple mode下选择position wall时不跳转至ust画面
      if (this.isSimple && (this.selectedModelData.category === 4 || this.selectedModelData.category === 5) && value === 2) {
        this.$router.push('/page/advanceMode')
        this.SET_ISSIMPLE(false)
        this.SET_TABACTIVENAME('Advanced')
        this.SET_ISUSTWALL(true)
        this.SET_POSITION(value)
        return
      }
      if (value === 1 || value === 2) {
        let vals = {}
        vals.max = this.temVLensShift.min * (-1)
        vals.min = this.temVLensShift.max * (-1)
        this.VLENSSHIFT(vals)
        if (vals.max < 0) {
          this.SET_VLENSSHIFT(vals.max * 100)
        } else if (this.vLensShiftNow) {
          this.SET_VLENSSHIFT(0)
        }
      } else if (value === 0) {
        let vals = {}
        vals.max = this.temVLensShift.max
        vals.min = this.temVLensShift.min
        this.VLENSSHIFT(vals)
        if (vals.min > 0) {
          this.SET_VLENSSHIFT(vals.min * 100)
        } else if (this.vLensShiftNow) {
          this.SET_VLENSSHIFT(0)
        }
      }
      let temoPjz = this.graph.pjZ
      let limit = -this.$commonViewJs.getMaxOutRoomH(this.initScreenSize.h) + this.limitData
      if ((this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) || this.selectedModelData.category === 4) {
        if (this.throw_distance_checked && this.screen_size_checked) {
          temoPjz = this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * this.vLensShiftNow / 100)
        } else if (this.throw_distance_checked && !this.screen_size_checked) {
          var screenI = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
          temoPjz = this.houseInfo.roomH - (this.flToB + screenI.calY / 2 - screenI.calY * this.vLensShiftNow / 100)
          limit = -this.$commonViewJs.getMaxOutRoomH(screenI.calY) + this.limitData
        }
      }
      if (temoPjz < limit) {
        temoPjz = limit
      }
      this.PJZ(temoPjz)
      this.SET_ISUSTWALL(this.selectedModelData.category === 4 && value === 2)
      this.SET_HLENSSHIFT(0)
      this.SET_POSITION(value)
      this.changeDwhSelect()
      // this.checkIsElectron()
    },

    changeBoardStatus () {
      this.screen_size_checked = false
      this.throw_distance_checked = false
      this.real_throw_distance_checked = false
      this.FTULocationStatus = 1
      this.changeDwhSelect()
      this.changeScreenSize()
      if (this.whiteboardStatus) {
        this.$commonJs.getBoardTop()
      } else {
        if (this.throwError) {
          this.SET_THROWERROR(false)
          this.PJY(this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMin))
        }
        this.SET_FLOOR2BOTTOM(this.floor2bottom + this.screenBottom2board)
      }
    },

    changeFingerStatus () {
      this.screen_size_checked = false
      this.throw_distance_checked = false
      this.real_throw_distance_checked = false
      this.changeDwhSelect()
      if (this.whiteboardStatus) this.$commonJs.getBoardTop()
    },

    PjyShowRangeError (visible, messageKey, message) {
      // 显示size输入时的弹框，可能会用到，（勿删！！！）
      // let msg = this.$t('T_MSG_AVAILABLE_RANGE', {size: message})
      // this[visible] = true
      // this[messageKey] = msg
      // setTimeout(() => {
      //   this[visible] = false
      // }, 3000)
    },

    RhShowRangeError (visible, messageKey, message) {
      let msg = this.$t('T_MSG_UST_ROOM_HIGHT_AVAILABLE_RANGE', {size: message + this.unitLabel})
      this[visible] = true
      this[messageKey] = msg
      setTimeout(() => {
        this[visible] = false
      }, 3000)
    },

    changeDiagonal () {
      let defaultDistData = this.selectRatioData
      this.currentDistData = defaultDistData.throwRange.w
      this.SET_THROWDISSLIDERMIN(this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMin))
      this.SET_THROWDISSLIDERMAX(this.$commonViewJs.calScreensizeToDistanceTele(this.ratioScreenSizeMax))
      // this.throwDisSliderMin = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMin)
      // this.throwDisSliderMax = this.$commonViewJs.calScreensizeToDistanceTele(this.ratioScreenSizeMax)
      // this.throwDisSliderw = this.$commonViewJs.getKy()
      // this.throwDisSlidert = this.$commonViewJs.getLy()
      this.SET_THROWDISSLIDERW(this.$commonViewJs.getKy())
      this.SET_THROWDISSLIDERT(this.$commonViewJs.getLy())
      if (this.ustThrowDisSlidertMax) {
        this.throwDisSlidert = this.ustThrowDisSlidertMax + this.ustLensToFrontPj
        if (this.throwDisSliderw > this.throwDisSlidert) this.throwDisSlidert = this.throwDisSliderw
      }
      this.throwDisSliderWidth = (this.throwDisSlidert - this.throwDisSliderw) / (this.throwDisSliderMax - this.throwDisSliderMin) * 100
      this.throwDisWidth()
    },

    throwDisSliderDataFormat (val) {
      return this.$commonJs.changeUnit(Number(val) + this.throwDisSliderMin, this.graph.unit, false, true)
    },
    throwDisSliderCurrentFormat (val) {
      return this.$commonJs.changeUnit(this.graph.pjY, this.graph.unit, false, true)
    },
    getLimitDistance (val) {
      // eslint-disable-next-line no-unused-vars
      let {min, max} = this.getPjyRangeNoChangeUnit()
      if (val > max) {
        return max
      } else {
        return val
      }
    },
    throwDisWidth () {
      if (this.$refs.throwDisSliderRangeFlag) {
        // let nowPjyT = this.$commonViewJs.getLy()
        // let persentT = (nowPjyT - this.throwDisSliderMin) / (this.throwDisSliderMax - this.throwDisSliderMin)
        // let persent = persentT * 100
        // let d = (this.throwDisSlidert - this.throwDisSliderw) / (this.throwDisSliderMax - this.throwDisSliderMin) * 100
        // if (persent > 100) {
        //   this.throwDisSliderWidth = d - (persent - 100)
        // }
        if (this.throwDisSliderMaxFormat === this.throwDisSliderwFormat) {
          this.$refs.throwDisSliderRangeFlag.$el.style.width = 0 + '%'
        } else {
          this.$refs.throwDisSliderRangeFlag.$el.style.width = this.throwDisSliderWidth + '%'
        }
      }
    },

    /**
     * 计算screen size栏
     */
    screenSizeWidth (width) {
      let screenSizeTele = this.$commonViewJs.getScreenByFromDistTele(this.graph.pjY)
      let screenSizeWide = this.screenSize
      if (width) screenSizeWide = width
      screenSizeTele = screenSizeTele < this.ratioScreenSizeMin ? this.ratioScreenSizeMin : screenSizeTele
      screenSizeWide = screenSizeWide < screenSizeTele ? screenSizeTele : screenSizeWide
      this.realThrowDisSliderRangeMax = screenSizeWide - screenSizeTele
      let sizeDis = this.ratioScreenSizeMax - this.ratioScreenSizeMin
      this.$refs.realThrowDisSliderRangeFlag.$el.style.left = (screenSizeTele - this.ratioScreenSizeMin) / sizeDis * 100 + '%'
      this.$refs.realThrowDisSliderRangeFlag.$el.style.width = this.realThrowDisSliderRangeMax / sizeDis * 100 + '%'
      let lef = (screenSizeTele - this.ratioScreenSizeMin) / sizeDis * 100
      this.$refs.distanceLockedSizetFormat.style.left = lef - 5 + '%'
      this.$refs.distanceLockedSizewFormat.style.left = (screenSizeWide - this.ratioScreenSizeMin) / sizeDis * 100 - 5 + '%'
    },

    formatTooltipScreenSize (val) {
      return this.dwhSelect === '0' ? val : this.$commonJs.changeUnit(val, this.graph.unit, false, true)
    },

    screenSizeChange (val) {
      if (this.screenSizeActive.length > 0) {
        this.dwhBool = true
        this.screenSizeCollapseClass = 'screen-size-collapse-open'
      } else {
        this.dwhBool = false
        this.screenSizeCollapseClass = 'screen-size-collapse-close'
      }
    },

    throwDistanceChange (val) {
      if (this.throwActive.length > 0) {
        this.throwValBool = true
      } else {
        this.throwValBool = false
      }
    },

    lensShiftChange (key) {
      if (key) {
        this.SET_LENSSHIFTRANGEBOOL(true)
      } else {
        this.SET_LENSSHIFTRANGEBOOL(false)
      }
    },

    getEle (val) {
      if (val === '0') {
        this.$el.querySelector('#throwdistance').before(this.$el.querySelector('#screensize'))
        this.$el.querySelector('#screensize').after(this.$el.querySelector('#throwdistance'))
        this.SET_SCREENSIZECHECKED(true)
        this.SET_REALTHROWDISTANCECHECKED(false)
        this.$nextTick(() => {
          this.throwDisWidth()
        })
      } else {
        this.$el.querySelector('#screensize').before(this.$el.querySelector('#throwdistance'))
        this.$el.querySelector('#throwdistance').after(this.$el.querySelector('#screensize'))
        this.SET_SCREENSIZECHECKED(false)
        this.SET_REALTHROWDISTANCECHECKED(true)
      }
      this.SET_MDDEDATA(val)
    },

    resetScreenByPjy () {
      // 获取黑边的长宽
      var initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
      this.SET_INITSCREENSIZEW(initScreen.calX)
      this.SET_INITSCREENSIZEH(initScreen.calY)
      this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY))
      let screen = this.$commonViewJs.getScreenXyFromDist(this.graph.pjY)
      this.SCRNW(screen.calX)
      this.SCRNH(screen.calY)
      if (this.isSimple && this.modeData === '1') {
        this.screenSizeWidth()
      }
    },
    // handleCollapseChange (value) {
    //   if (value.indexOf('1') !== -1) {
    //     this.angle_activeNames = ['0']
    //     this.ambient_activeNames = ['0']
    //     this.out_activeNames = ['0']
    //   }
    // },

    /**
     * 根据键盘移动数据
     * data表示移动之后的值
     */
    mouseMoveData (moveData) {
      if (this.screenSizeMouseOn) {
        if (this.isSimple && this.modeData === '0') {
          let size = moveData
          this.diagonalSliderCurrent = size
          this.screenSizeData = size
          this.changeScreenSize()
          this.SET_SCREENSIZECHECKED(true)
          this.resetScreenByPjy()
          // this.throwDisWidth()
        } else if (this.isSimple && this.modeData === '1') {
          this.checkScreenSizeNoPjy(moveData)
        }
      } else if (this.distanceMouseOn) {
        let dis = moveData
        dis = dis < this.throwDisSliderw ? this.throwDisSliderw : (dis > this.throwDisSlidert ? this.throwDisSlidert : dis)
        this.throwDisChangedSizeLockedCurrent = dis
        this.SET_GRAPH_PJY(this.throwDisChangedSizeLockedCurrent)
      }
    },
    handleKeyDown (e) {
      if (!this.isSimple) {
        return
      }
      if (e.keyCode > 36 && e.keyCode < 41 && (this.screenSizeMouseOn || this.distanceMouseOn)) { e.preventDefault() }
      let newTime = new Date().getTime()
      if (newTime - this.moveTime < 500) {
        return
      }
      this.moveTime = new Date().getTime()
      let inchMove = 0.01
      let comMove = this.$commonJs.getMoveDisByUnit()
      if (e.keyCode === 37) {
        if (this.screenSizeMouseOn) {
          if (this.dwhSelect === '0') {
            this.mouseMoveData(Number(this.screenSize) - inchMove)
          } else if (this.dwhSelect === '1') {
            let s = this.$commonViewJs.getScreenSizeByCalX(this.graph.scrnW - comMove, this.aspectRatio).size
            this.mouseMoveData(s)
          } else if (this.dwhSelect === '2') {
            let s = this.$commonViewJs.getScreenSizeByCalY(this.graph.scrnH - comMove, this.aspectRatio).size
            this.mouseMoveData(s)
          }
        } else if (this.distanceMouseOn) {
          this.mouseMoveData(this.graph.pjY - comMove)
        }
      } else if (e.keyCode === 39) {
        if (this.screenSizeMouseOn) {
          if (this.dwhSelect === '0') {
            this.mouseMoveData(Number(this.screenSize) + inchMove)
          } else if (this.dwhSelect === '1') {
            let s = this.$commonViewJs.getScreenSizeByCalX(this.graph.scrnW + comMove, this.aspectRatio).size
            this.mouseMoveData(s)
          } else if (this.dwhSelect === '2') {
            let s = this.$commonViewJs.getScreenSizeByCalY(this.graph.scrnH + comMove, this.aspectRatio).size
            this.mouseMoveData(s)
          }
        } else if (this.distanceMouseOn) {
          this.mouseMoveData(this.graph.pjY + comMove)
        }
      }
    },
    handelKeyUp () {
      this.moveTime = 0
    },
    ustWallMinPjZ () {
      let tmpPjY
      if (this.throw_distance_checked && !this.screen_size_checked && !this.real_throw_distance_checked) {
        tmpPjY = this.$commonViewJs.calScreensizeToDistanceWide(this.ratioScreenSizeMax) + this.ustLensToFrontPj
      } else {
        tmpPjY = this.$commonViewJs.getLy()
      }
      let wSize = this.$commonViewJs.getScreenSizeFromDist(tmpPjY)
      let wSizeInch = this.$commonViewJs.getScreenByFromDistWide(tmpPjY)
      let v1b = wSizeInch * this.selectRatioData.v1b.w.a + this.selectRatioData.v1b.w.b
      let l = (wSize.calY - this.graph.scrnH) / 2
      let vlensShiftN = (wSize.calY / 2 + v1b - this.selectedLensData.mu - l) / this.initScreenSize.h * (-1)
      let tmpPjZ = this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * vlensShiftN)
      if (this.isUSTWall && tmpPjZ.toFixed(2) * 1 <= (this.selectedLensData.lens2mptsHeight - this.selectedLensData.mpts2wallBottomHeight + this.selectedModelData.wallHeight / 10).toFixed(2) * 1) {
        return true
      } else {
        return false
      }
    },
    setSpecificInfo (data) {
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(defaultRatio, data)
      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)

      this.ASPECTRATIO(data.lcd.aspectRatio)

      // 为超短焦设置默认vlens shift
      if (this.selectedModelData.type === 1 && data.lcd.lensShiftRange.v.min === 0 && data.lcd.lensShiftRange.v.max === 0) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let v1b = defaultDistInfo.screenSize.w.min * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        let res = (initSize.calY / 2 + v1b - data.mu) / initSize.calY
        let va = {}
        if ((this.current_position === 1 || this.current_position === 2)) {
          this.SET_VLENSSHIFT(res * 100 * -1)
        } else {
          this.SET_VLENSSHIFT(res * 100)
        }
        va.max = res
        va.min = res
        this.VLENSSHIFT(va)
        this.SET_TEMVLENSSHIFT(va)
      }
    },

    ...mapMutations([
      'SCRNW',
      'SCRNH',
      'ROOMH',
      'ROOMW',
      'ROOMD',
      'PJY',
      'SET_UNIT',
      'SET_GRAPH_ROOMW',
      'SET_GRAPH_ROOMH',
      'SET_GRAPH_ROOMD',
      'SET_GRAPH_PJY',
      'SET_GRAPH_SCRNW',
      'SET_GRAPH_SCRNH',
      'SET_SCREENSIZE',
      'SET_BRIGHTNESS',
      'SET_VANGLE',
      'SET_VANGLEFLAG',
      'SET_HANGLE',
      'SET_HANGLEFLAG',
      'SET_OFFSET',
      'SET_FLOOR2BOTTOM',
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'ASPECTRATIO',
      'PJZ',
      'SET_GAIN',
      'SET_APPLICATION',
      'SET_THROWDISTANCECHECKED',
      'SET_SCREENSIZECHECKED',
      'SET_REALTHROWDISTANCECHECKED',
      'SET_BLACKSIZE',
      'SET_CENTERPOSITIONINIT',
      'SET_SCREENPOSITIONCHECKED',
      'SET_FLTOB',
      'SET_FLTOL',
      'SELECTRATIODATA',
      'PJX',
      'SET_INITSCREENSIZEW',
      'SET_INITSCREENSIZEH',
      'SET_DASHFLAG',
      'VLENSSHIFT',
      'SET_VLENSSHIFT',
      'SET_HLENSSHIFT',
      'SET_PROJECTORCHECKED',
      'SET_POSITION',
      'SET_SCREENMOVECHECKED',
      'SET_TEMVLENSSHIFT',
      'SET_ISUSTWALL',
      'SET_USTLENSHIFTV',
      'SET_FINGERTOUCHSTATUS',
      'SET_FTULOCATIONSTATE',
      'SET_WHITEBOARDSTATUS',
      'SET_OUTOFSPECVAL',
      'SET_ISOUTOFSPEC',
      'SCREENSIZE',
      'SET_CURVESHAPE',
      'SET_CURVEDIRECTION',
      'SET_CURVEDEPTH',
      'SET_INDANGLESWITCH',
      'SET_INDANGLEREMAINPINTS',
      'SET_LENSSHIFTRANGEBOOL',
      'SET_LENSSHIFTRANGE',
      'SET_BRIGHTNESSGUIDE',
      'SET_SETTINGACTIVE',
      'SET_SCREENACTIVE',
      'SET_THROWACTIVE',
      'SET_FONTSIZE',
      'SET_DISABLEDNONE',
      'SET_SCREENSIZEACTIVE',
      'SET_THROWDISSLIDERTFORMAT',
      'SET_THROWDISSLIDERWFORMAT',
      'SET_MDDEDATA',
      'SET_ISSIMPLE',
      'SET_TABACTIVENAME',
      'BOARDW',
      'BOARDH',
      'SET_USTTHROWDISSLIDERTMAX',
      'SET_USTSCREENSIZEMAX',
      'SET_RATIOSCREENSIZEMIN',
      'SET_RATIOSCREENSIZEMAX',
      'SET_THROWERROR',
      'SET_FLOORFOOTPROJECTORCHECKED',
      'SET_THROWDISSLIDERMIN',
      'SET_THROWDISSLIDERMAX',
      'SET_THROWDISSLIDERW',
      'SET_THROWDISSLIDERT'
    ])
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyDown, false)
    window.removeEventListener('keyup', this.handelKeyUp, false)
  },

  computed: {
    ...mapState([
      'graph',
      'deepmInit',
      'heightmInit',
      'proportion',
      'matchingLensID',
      'selectedModelData',
      'screenSize',
      'brightness',
      'vAngleFlag',
      'vAngle',
      'hAngleFlag',
      'hAngle',
      'offset',
      'floor2bottom',
      'selectedLensData',
      'selectRatioData',
      'houseInfo',
      'gain',
      'throwDistanceChecked',
      'screenSizeChecked',
      'realThrowDistanceChecked',
      'aspectRatio',
      'centerPointData',
      'centerPositionInit',
      'drawData',
      'blackDrawData',
      'flToB',
      'flToL',
      'screenActive',
      'throwDisActive',
      'initScreenSize',
      'vLensShiftNow',
      'hLensShiftNow',
      'screen4Point',
      'unitDataOptions',
      'limitData',
      'temVLensShift',
      'isUSTWall',
      'fingerTouchStatus',
      'FTULocationState',
      'keyStoneHorizontal',
      'isVAngleOut',
      'outOfSpecVal',
      'isOutOfSpec',
      'ustLensToFrontPj',
      'isSimple',
      'lensShiftRangeBool',
      'lensShiftRange',
      'brightnessGuide',
      'dwSelectSearch',
      'indAngleSwitch',
      'isOnCornerAreas',
      'curveShape',
      'touchWallFlag',
      'SettingActive',
      'screenActive',
      'setfontSize',
      'position',
      'DisableNone',
      'curveDirection',
      'curveDepth',
      'searchTabActive',
      'whiteboardStatus',
      'ustThrowDisSlidertMax',
      'ustScreenSizeMax',
      'ratioScreenSizeMin',
      'ratioScreenSizeMax',
      'FTUT2screenT',
      'board2screenH',
      'board2screenW',
      'boardStatusTop',
      'throwError',
      'floorFootProjectorChecked',
      'throwDisSliderMin',
      'throwDisSliderMax',
      'throwDisSliderw',
      'throwDisSlidert',
      'isHistoryRowClick'
    ]),

    ...mapGetters([
      'unitLabel',
      'selectedLensData_lcd_distInfo'
    ]),
    isFraction () {
      return this.unitData === 'T_FEET_FRACTION' || this.unitData === 'T_INCH_FRACTION'
    },
    sliderL () {
      let nowPjy = this.$commonViewJs.getKy() - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      let persent = (nowPjy - this.throwDisSliderMin) / (this.throwDisSliderMax - this.throwDisSliderMin)
      return persent * 100
    },
    slidertL () {
      let nowPjy = this.throwDisSlidert - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      let persent = (nowPjy - this.throwDisSliderMin) / (this.throwDisSliderMax - this.throwDisSliderMin)
      return persent * 100
    },

    throwDisSlidertFormat () {
      let temp = this.throwDisSlidert - (this.isUSTWall ? this.ustLensToFrontPj : 0) - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      this.SET_THROWDISSLIDERTFORMAT(temp)
      return this.$commonJs.changeUnit(temp, this.graph.unit)
    },

    throwDisSliderwFormat () {
      let temp = this.throwDisSliderw - (this.isUSTWall ? this.ustLensToFrontPj : 0) - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      this.SET_THROWDISSLIDERWFORMAT(temp)
      return this.$commonJs.changeUnit(temp, this.graph.unit)
    },

    throwDisSliderMinFormat () {
      return this.$commonJs.changeUnit(this.throwDisSliderMin - (this.isUSTWall ? this.ustLensToFrontPj : 0), this.graph.unit)
    },

    throwDisSliderMaxFormat () {
      return this.$commonJs.changeUnit(this.throwDisSliderMax - (this.isUSTWall ? this.ustLensToFrontPj : 0), this.graph.unit)
    },

    lensShiftRangeSwitch: {
      get () {
        return this.lensShiftRange
      },
      set (val) {
        this.SET_LENSSHIFTRANGE(val)
      }
    },

    DisableN: {
      get () {
        return this.DisableNone
      },
      set (val) {
        this.SET_DISABLEDNONE(val)
      }
    },

    Position: {
      get () {
        return this.position
      },
      set (val) {
        this.SET_POSITION(val)
      }
    },

    brightnessGuideSwitch: {
      get () {
        return this.brightnessGuide
      },
      set (val) {
        this.SET_BRIGHTNESSGUIDE(val)
      }
    },

    diagonalMinFormat () {
      if (!this.selectRatioData) {
        return 0
      }
      if (this.dwhSelect === '0') {
        return this.diagonalMin
      } else {
        return this.$commonJs.changeUnit(this.diagonalMin, this.graph.unit)
      }
    },

    diagonalMaxFormat () {
      if (!this.selectRatioData) {
        return 0
      }
      if (this.dwhSelect === '0') {
        return this.diagonalMax
      } else {
        return this.$commonJs.changeUnit(this.diagonalMax, this.graph.unit)
      }
    },

    distanceLockedSizetFormat () {
      let distanceLockedSizet = this.$commonViewJs.getScreenByFromDistTele(this.graph.pjY)
      if (distanceLockedSizet < this.ratioScreenSizeMin) distanceLockedSizet = this.ratioScreenSizeMin
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentSizet = distanceLockedSizet
      if (this.dwhSelect === '0') {
        return distanceLockedSizet.toFixed(2)
      } else {
        let wh = this.$commonViewJs.getScreenXYByScreenSize(distanceLockedSizet, this.aspectRatio)
        let t
        if (this.dwhSelect === '1') {
          t = wh.calX
        }
        if (this.dwhSelect === '2') {
          t = wh.calY
        }
        return this.$commonJs.changeUnit(t, this.graph.unit, false, true)
      }
    },

    distanceLockedSizewFormat () {
      let distanceLockedSizew
      if (this.ustScreenSizeMax) {
        distanceLockedSizew = this.ustScreenSizeMax
      } else {
        distanceLockedSizew = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
      }
      this.$nextTick(() => {
        this.screenSizeWidth(distanceLockedSizew)
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentSizew = distanceLockedSizew
      if (this.dwhSelect === '0') {
        return distanceLockedSizew.toFixed(2)
      } else {
        let wh = this.$commonViewJs.getScreenXYByScreenSize(distanceLockedSizew, this.aspectRatio)
        let w
        if (this.dwhSelect === '1') {
          w = wh.calX
        }
        if (this.dwhSelect === '2') {
          w = wh.calY
        }
        return this.$commonJs.changeUnit(w, this.graph.unit, false, true)
      }
    },

    unitData: {
      get () {
        return this.graph.unit
      },

      set (value) {
        this.SET_UNIT(value)
      }
    },

    brightnessData: {
      get () {
        return this.brightness
      },

      set (value) {
        if (isNaN(value)) value = '0'
        if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
          value = value.substr(1)
        }
        this.SET_BRIGHTNESS(value)
      }
    },

    vAngleDataComputed () {
      return this.vAngle
    },

    vAngleFlagData: {
      get () {
        return this.vAngleFlag
      },

      set (value) {
        if (this.throw_distance_checked && value) {
          this.SET_THROWDISTANCECHECKED(false)
          this.SET_DASHFLAG(true)
        } else {
          this.SET_DASHFLAG(false)
        }
        this.SET_VANGLEFLAG(value)
        if (value) {
          this.indAngRemainPoints = this.drawData[0]
          this.SET_SCREENMOVECHECKED(false)
        }
      }
    },
    indAngleSwitchData: {
      get () {
        return this.indAngleSwitch
      },
      set (value) {
        if (value) {
          if (this.vAngleFlag || this.hAngleFlag) {
            this.SET_INDANGLEREMAINPINTS(this.indAngRemainPoints)
          } else {
            this.SET_INDANGLEREMAINPINTS(this.drawData[0])
          }
          this.SET_DASHFLAG(false)
        } else {
          this.SET_VANGLEFLAG(false)
          this.SET_HANGLEFLAG(false)
        }
        this.SET_INDANGLESWITCH(value)
      }
    },

    hAngleDataComputed () {
      return this.hAngle
    },

    hAngleFlagData: {
      get () {
        return this.hAngleFlag
      },

      set (value) {
        if (this.throw_distance_checked && value) {
          this.SET_THROWDISTANCECHECKED(false)
          this.SET_DASHFLAG(true)
        } else {
          this.SET_DASHFLAG(false)
        }
        this.SET_HANGLEFLAG(value)
        if (value) {
          this.indAngRemainPoints = this.drawData[0]
          this.SET_SCREENMOVECHECKED(false)
        }
      }
    },
    screenSizeSlider: {
      get () {
        return parseFloat(this.screenSizeData)
      },
      set (value) {
        // let disMax = parseFloat(this.getScreenSizeRange().max)
        // if (value === disMax) {
        //   this.screenSizeData = value
        //   // return
        // }
        // this.throwDisWidth()
        this.diagonalSliderCurrent = value
        if (this.$refs['screenSizeSliderFlag'].dragging === true) {
          this.screenSizeData = value
          this.changeScreenSize()
          if (this.isSimple && this.modeData === '0') {
            this.SET_SCREENSIZECHECKED(true)
            this.resetScreenByPjy()
          }
        }
      }
    },

    roomW () {
      return this.houseInfo.roomW
    },

    roomH () {
      return this.houseInfo.roomH
    },

    roomD () {
      return this.houseInfo.roomD
    },

    pjY () {
      return this.graph.pjY
    },

    scrnW () {
      return this.graph.scrnW
    },

    scrnH () {
      return this.graph.scrnH
    },

    boardW () {
      return this.graph.boardW
    },

    boardH () {
      return this.graph.boardH
    },

    vLensShiftMax: {
      get () {
        return this.graph.vLensShift.max * 10000 / 100
      }
    },
    vLensShiftMin: {
      get () {
        return this.graph.vLensShift.min * 10000 / 100
      }
    },
    simpleUILensShiftDisable () {
      let state = (this.graph.vLensShift.max === this.graph.vLensShift.min) && (this.graph.hLensShift.max === this.graph.hLensShift.min)
      if (state) {
        this.SET_LENSSHIFTRANGE(false)
        this.SET_LENSSHIFTRANGEBOOL(false)
      }
      return state
    },
    screenSizeActive: {
      get () {
        return this.screenActive
      },
      set (val) {
        this.SET_SCREENSIZEACTIVE(val)
      }
    },

    throwActive: {
      get () {
        return this.throwDisActive
      },
      set (val) {
        this.SET_THROWACTIVE(val)
      }
    },

    hLensShiftMax: {
      get () {
        return this.graph.hLensShift.max * 10000 / 100
      }
    },
    hLensShiftMin: {
      get () {
        return this.graph.hLensShift.min * 10000 / 100
      }
    },

    SettingActiveNames: {
      get () {
        return this.SettingActive
      },
      set (val) {
        this.SET_SETTINGACTIVE(val)
      }
    },

    MaxOctagonH () {
      if (this.vLensShiftMax === this.vLensShiftMin) {
        return this.$commonJs.changeUnit((this.initScreenSize.h - this.graph.scrnH) / 2, this.graph.unit)
      } else if (this.vLensShiftMin > 0) {
        let dis = this.initScreenSize.h * (this.vLensShiftMax - this.vLensShiftMin) / 100
        return this.$commonJs.changeUnit((this.initScreenSize.h - this.graph.scrnH) / 2 + dis, this.graph.unit)
      } else if (this.vLensShiftMax < 0) {
        return this.$commonJs.changeUnit((this.initScreenSize.h - this.graph.scrnH) / 2, this.graph.unit)
      } else {
        let oldScrnH = this.initScreenSize.h * this.graph.vLensShift.max
        // let newScrenH = this.graph.scrnH * this.graph.vLensShift.max
        // let ScrenH = (oldScrnH - newScrenH) / 2
        // return this.$commonJs.changeUnit(oldScrnH + ScrenH, this.graph.unit)
        return this.$commonJs.changeUnit(oldScrnH, this.graph.unit)
      }
    },

    MinOctagonH () {
      if (this.vLensShiftMax === this.vLensShiftMin || this.vLensShiftMin > 0) {
        return this.$commonJs.changeUnit(Math.abs((this.initScreenSize.h - this.graph.scrnH) / 2), this.graph.unit)
      } else if (this.vLensShiftMax < 0) {
        let dis = this.initScreenSize.h * (this.vLensShiftMax - this.vLensShiftMin) / 100
        return this.$commonJs.changeUnit((this.initScreenSize.h - this.graph.scrnH) / 2 + dis, this.graph.unit)
      } else {
        let oldScrnH = this.initScreenSize.h * this.graph.vLensShift.max
        // let newScrenH = Math.abs(this.graph.scrnH * this.graph.vLensShift.min)
        // let ScrenH = (oldScrnH - newScrenH) / 2
        // return this.$commonJs.changeUnit(oldScrnH + ScrenH, this.graph.unit)
        return this.$commonJs.changeUnit(oldScrnH, this.graph.unit)
      }
    },

    HorizontalW () {
      if (this.vLensShiftMax === this.vLensShiftMin) {
        return this.$commonJs.changeUnit(Math.abs((this.initScreenSize.w - this.graph.scrnW) / 2), this.graph.unit)
      } else if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max === this.graph.hLensShift.min) {
        return this.$commonJs.changeUnit((this.initScreenSize.w - this.graph.scrnW) / 2, this.graph.unit)
      } else {
        let oldScrnW = this.initScreenSize.w * this.graph.hLensShift.max
        // let newScrenW = this.graph.scrnW * this.graph.hLensShift.max
        // let ScrenW = (oldScrnW - newScrenW) / 2
        // return this.$commonJs.changeUnit(oldScrnW + ScrenW, this.graph.unit)
        return this.$commonJs.changeUnit(oldScrnW, this.graph.unit)
      }
    },

    screenSizeDataComputed: {
      get () {
        return (this.screenSize * 1).toFixed(2)
      }
    },

    offsetComputed () {
      return this.offset
    },

    selectedLensOptions () {
      return this.selectedLensData_lcd_distInfo.map((item) => {
        return {
          key: item.ratio,
          value: item.ratio
        }
      })
    },

    unit () {
      return this.graph.unit
    },

    aspectRatioData: {
      get () {
        return this.aspectRatio
      },

      set (value) {
        this.SET_USTLENSHIFTV()
        this.ASPECTRATIO(value)
      }
    },

    f_d2sComputed () {
      return this.graph.f_d2s
    },

    gainComputed () {
      return this.gain
    },
    floor_footProjector_checked: {
      get () {
        return this.floorFootProjectorChecked
      },
      set (value) {
        this.SET_FLOORFOOTPROJECTORCHECKED(value)
      }
    },
    throw_distance_checked: {
      get () {
        return this.throwDistanceChecked
      },
      set (value) {
        if (this.screen_size_checked) {
          this.SET_CENTERPOSITIONINIT(this.centerPointData)
        }
        if (!this.vAngleFlag && !this.hAngleFlag) {
          this.SET_FLTOB(this.houseInfo.roomH - this.screen4Point[3].z)
          this.SET_FLTOL(this.screen4Point[3].x)
        }
        this.SET_THROWDISTANCECHECKED(value)
        if (this.screen_size_checked && value && this.ustWallMinPjZ()) {
          let ustThrowDisSlidertMax = this.$commonJs.changeUnit(this.pjYData, this.graph.unit, true)
          this.SET_USTTHROWDISSLIDERTMAX(ustThrowDisSlidertMax)
        } else {
          this.SET_USTTHROWDISSLIDERTMAX(0)
        }
        this.changeDiagonal()
        if (!this.screen_size_checked && value && this.ustWallMinPjZ()) {
          this.SET_USTSCREENSIZEMAX(this.screenSize * 1)
        } else {
          this.SET_USTSCREENSIZEMAX(0)
        }
        if (value) {
          this.SET_DASHFLAG(false)
          this.SET_SCREENMOVECHECKED(false)
          this.SET_VANGLEFLAG(false)
          this.SET_HANGLEFLAG(false)
        }
      }
    },
    screen_size_checked: {
      get () {
        return this.screenSizeChecked
      },
      set (value) {
        // 勿删，备用
        // this.SET_BLACKSIZE(this.$commonViewJs.calDistanceInitToScreensizeWide(this.graph.pjY))
        this.SET_SCREENSIZECHECKED(value)
        // if (value && this.realThrowDistanceChecked) {
        this.SET_REALTHROWDISTANCECHECKED(false)
        //   this.resetScreenByPjy()
        // }
        // if (!value) {
        this.PJY(this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize))
        let screen = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
        let temoPjz = this.graph.pjZ
        let temoPjx = this.graph.pjX
        let limitPjz = this.$commonViewJs.getMaxOutRoomH(screen.calY)
        let limitPjx = this.$commonViewJs.getMaxOutRoomW(screen.calX)
        temoPjz = this.$commonJs.checkRange(temoPjz, -limitPjz + this.limitData, this.houseInfo.roomH - this.limitData)
        temoPjx = this.$commonJs.checkRange(temoPjx, -limitPjx + this.limitData, this.houseInfo.roomW + limitPjx - this.limitData)
        this.PJZ(temoPjz)
        this.PJX(temoPjx)
        this.checkIsElectron()
        this.throwDisWidth()
        // }
        // this.throwDisSliderRangeData = this.graph.pjY - this.$commonViewJs.getKy()
        if (value && this.throw_distance_checked && this.ustWallMinPjZ()) {
          let ustThrowDisSlidertMax = this.$commonJs.changeUnit(this.pjYData, this.graph.unit, true)
          this.SET_USTTHROWDISSLIDERTMAX(ustThrowDisSlidertMax)
        } else {
          this.SET_USTTHROWDISSLIDERTMAX(0)
        }
      }
    },

    real_throw_distance_checked: {
      get () {
        return this.realThrowDistanceChecked
      },
      set (value) {
        this.SET_REALTHROWDISTANCECHECKED(value)
        if (value) {
          if (this.screenSizeChecked) {
            this.SET_SCREENSIZECHECKED(false)
            this.PJY(this.$commonViewJs.calScreensizeToDistanceWide(this.screenSize))
            this.checkIsElectron()
            this.throwDisWidth()
          }
          // this.screenSizeWidth()
        } else {
          this.PJY(this.graph.pjY * (1 + this.limitData))
        }
      }
    },
    realThrowDisSliderRangeData: {
      get () {
        let screenSizeTele = this.$commonViewJs.getScreenByFromDistTele(this.graph.pjY)
        if (screenSizeTele < this.ratioScreenSizeMin) screenSizeTele = this.ratioScreenSizeMin
        let re = parseFloat(this.screenSize - screenSizeTele)
        return re < 0 ? 0 : re
      },
      set (value) {
        if (this.isSimple && this.modeData === '0') {
          this.SET_SCREENSIZECHECKED(true)
        }
        if (this.realThrowDistanceChecked) {
          // if (this.$refs['realThrowDisSliderRangeFlag'].dragging === true) {
          let screenSizeTele = this.$commonViewJs.getScreenByFromDistTele(this.graph.pjY)
          if (screenSizeTele < this.ratioScreenSizeMin) screenSizeTele = this.ratioScreenSizeMin
          let size = value + screenSizeTele
          this.checkScreenSizeNoPjy(size)
          // }
        }
      }
    },

    floor2bottomComputed () {
      return this.floor2bottom
    },

    screenSizeOut () {
      let distInfoVal = this.$commonJs.findCurrentDistInfo(this.selectedLensData)
      return this.screenSizeData > distInfoVal.screenSize.w.max || this.screenSizeData < distInfoVal.screenSize.w.min
    },

    screen2LensFlag () {
      return this.graph.f_s2d.t.a === 0 && this.graph.f_s2d.t.b === 0 && this.screen_size_checked
    },
    isCellingDisable () {
      return this.selectedModelData.modelSeries === 'BoliviaUSTH' || this.selectedModelData.positionCeiling === false
    },
    isWallDisable () {
      return this.selectedModelData.category !== 4
    },
    touchDisable () {
      // if (!this.isUSTWall) {
      //   return true
      // }
      // let arr = this.selectedLensOptions.map((item) => item.value)
      // return arr.indexOf('16:6') === -1 && arr.indexOf('21:9') === -1
      return !this.isUSTWall
    },
    touchStatus: {
      get () {
        if (!this.isUSTWall) {
          return 1
        }
        return this.fingerTouchStatus ? 0 : 1
      },
      set (value) {
        this.SET_FINGERTOUCHSTATUS(!value)
      }
    },
    FTULocationStatus: {
      get () {
        if (!this.isUSTWall) {
          return 1
        }
        return this.FTULocationState ? 0 : 1
      },
      set (value) {
        this.SET_FTULOCATIONSTATE(!value)
      }
    },
    boardStatus: {
      get () {
        if (!this.isUSTWall) {
          return 1
        }
        return this.whiteboardStatus ? 0 : 1
      },
      set (value) {
        this.SET_WHITEBOARDSTATUS(!value)
      }
    },
    whiteboardSupport () {
      if (this.selectedModelData.whiteboardSupport && this.isUSTWall) {
        return true
      } else {
        return false
      }
    },
    intFuncSupport () {
      if (this.whiteboardSupport && this.selectedModelData.intFuncSupport) {
        return true
      } else {
        return false
      }
    },
    FTULocationDisable () {
      if (this.fingerTouchStatus && this.whiteboardSupport && this.whiteboardStatus) {
        return false
      } else {
        return true
      }
    },
    ustOffsetMax () {
      // ArmLenMax = 0の場合,対象機種Aなので、Wall2ScreenMax = 100mmで終了
      if (this.selectedModelData.ArmLenMax === 0) {
        return this.$commonJs.changeUnit(this.ustOffsetMaxVal, this.graph.unit, false, true)
      } else {
        // 壁掛け金具のオフセット
        let offset
        // 現在の壁掛け金具のアームの長さ
        let CurrentArmLen
        // 現在の投写距離
        let CurrentDist
        // 壁からスクリーンの最大距離＝ボード厚み最大
        let Wall2ScreenMax
        // CurrentScreenSize < ChangeSize,オフセット切り替え基準の投写サイズ未満OffsetにOffsetLessThanChangeSizeの値を代入する.
        // 上記以外の場合,オフセット切り替え基準の投写サイズ以上OffsetにOffsetMoreThanChangeSizeの値を代入する
        // 用cm来计算
        if (this.screenSizeData < this.selectedModelData.ChangeSize) {
          offset = this.$commonJs.changeUnit(this.selectedModelData.OffsetLessThanChangeSize, 'T_MILLIMETER_MM', true)
        } else {
          offset = this.$commonJs.changeUnit(this.selectedModelData.OffsetMoreThanChangeSize, 'T_MILLIMETER_MM', true)
        }
        CurrentDist = this.$commonJs.changeUnit(this.pjYData, this.graph.unit, true)
        CurrentArmLen = CurrentDist + offset
        Wall2ScreenMax = this.$commonJs.changeUnit(this.selectedModelData.ArmLenMax, 'T_MILLIMETER_MM', true) - CurrentArmLen
        return this.$commonJs.changeUnit(Wall2ScreenMax < 0 ? 0 : Wall2ScreenMax, this.graph.unit, false)
      }
    },
    isHAngleOut () {
      return !this.keyStoneHorizontal
    },
    outOfSpec: {
      get () {
        return this.outOfSpecVal
      },
      set (value) {
        this.SET_OUTOFSPECVAL(value)
        this.SET_ISOUTOFSPEC(value)
        if (!value) {
          let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
          this.checkScreenSize(result)
        }
      }
    },
    throwDisSliderData: {
      get () {
        let res = this.pjY.toFixed(1) * 1
        if (res > this.throwDisSliderMax) {
          res = this.throwDisSliderMax
        } else if (res < this.throwDisSliderMin) {
          res = this.throwDisSliderMin
        }
        return res
      },
      set (value) {
        let cu = this.getLimitDistance(value)
        this.throwdisCurrnet = cu
        if (this.$refs['throwDisSliderFlag'].dragging === true) {
          this.SET_GRAPH_PJY(cu)
          this.changeSliderDistance()
        }
      }
    },
    throwDisSli () {
      let m = this.throwDisSliderMax
      if (this.throwDisSlidert - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) > m) {
        return m - (this.throwDisSliderw - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0))
      }

      return this.throwDisSlidert - this.throwDisSliderw
    },
    throwDisSliderRangeData: {
      get () {
        let res = this.graph.pjY + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0) - this.throwDisSliderw
        return res < this.limitData ? 0 : (res > this.throwDisSli ? this.throwDisSli : res)
      },
      set (value) {
        // let cu = this.getLimitDistance(this.$commonViewJs.getKy() + value)
        let cu = this.$commonViewJs.getKy() + value - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
        this.throwDisChangedSizeLockedCurrent = cu
        // this.throwDisWidth()
        if (this.$refs['throwDisSliderRangeFlag'].dragging === true) {
          this.SET_GRAPH_PJY(cu)
        }
      }
    },

    floor2topCpmuted () {
      if (this.drawData) {
        let textName2 = this.drawData[0][3].z - this.drawData[0][0].z
        let f2top = this.houseInfo.roomH - (this.graph.scrnH + this.floor2bottom) + (this.graph.scrnH - textName2)
        return this.$commonJs.changeUnit(f2top, this.graph.unit) + ' ' + (this.unitData === 'T_FEET_FRACTION' || this.unitData === 'T_INCH_FRACTION' ? '' : this.unitLabel)
      }
      return null
    },

    floor2bottomCpmuted () {
      return this.$commonJs.changeUnit(this.floor2bottom, this.graph.unit) + ' ' + (this.unitData === 'T_FEET_FRACTION' || this.unitData === 'T_INCH_FRACTION' ? '' : this.unitLabel)
    },

    floor2footProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ
      let f2foot = f2l - this.selectedLensData.fe
      if (this.selectedModelData.lensExchange === true) {
        f2foot = f2l - BrightnessDataFe
      }
      this.isNegativeNum = (f2foot * 10).toFixed(0) < 0
      return this.$commonJs.changeUnit(f2foot, this.graph.unit) + ' ' + (this.unitData === 'T_FEET_FRACTION' || this.unitData === 'T_INCH_FRACTION' ? '' : this.unitLabel)
    },

    floor2footProjectorComputed () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ
      let f2foot = f2l - this.selectedLensData.fe
      if (this.selectedModelData.lensExchange === true) {
        f2foot = f2l - BrightnessDataFe
      }
      this.isNegativeNum = (f2foot * 10).toFixed(0) < 0
      return this.$commonJs.changeUnit(f2foot, this.graph.unit)
    },

    floor2upperProjector () {
      let BrightnessDataUp = this.getBrightnessUp
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let f2upper = f2l - BrightnessDataUp
        return this.$commonJs.changeUnit(f2upper > 0 ? f2upper : 0, this.graph.unit) + ' ' + (this.unitData === 'T_FEET_FRACTION' || this.unitData === 'T_INCH_FRACTION' ? '' : this.unitLabel)
      } else {
        let f2upper = f2l - this.selectedLensData.up
        return this.$commonJs.changeUnit(f2upper > 0 ? f2upper : 0, this.graph.unit) + ' ' + (this.unitData === 'T_FEET_FRACTION' || this.unitData === 'T_INCH_FRACTION' ? '' : this.unitLabel)
      }
    },

    floor2upperProjectorLx () {
      let BrightnessDataUp = this.getBrightnessUp
      let BrightnessDataCc = this.getBrightnessCc
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let f2upperlx = f2l + BrightnessDataCc - BrightnessDataUp
        return this.$commonJs.changeUnit(f2upperlx, this.graph.unit) + ' ' + (this.unitData === 'T_FEET_FRACTION' || this.unitData === 'T_INCH_FRACTION' ? '' : this.unitLabel)
      } else {
        let f2upperlx = f2l + BrightnessDataCc - this.selectedLensData.up
        return this.$commonJs.changeUnit(f2upperlx, this.graph.unit) + ' ' + (this.unitData === 'T_FEET_FRACTION' || this.unitData === 'T_INCH_FRACTION' ? '' : this.unitLabel)
      }
    },

    getBrightnessFe () {
      let brightnessfe
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessfe = this.Brightness.optionLens[i].fe / 10
          }
        }
      }
      return brightnessfe
    },

    getBrightnessUp () {
      let brightnessup
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessup = this.Brightness.optionLens[i].up / 10
          }
        }
      }
      return brightnessup
    },

    getBrightnessCc () {
      let brightnesscc
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnesscc = this.Brightness.optionLens[i].cc / 10
          }
        }
      }
      return brightnesscc
    },

    shape_input: {
      get () {
        return this.curveShape
      },
      set (value) {
        this.SET_CURVESHAPE(value)
        this.SET_OFFSET(0)
        if (value === '0') {
          this.dwhSelect = '1'
        } else {
          this.dwhSelect = '2'
        }
        this.$refs.CurveCondition.resetCurveValue()
      }
    },

    screenBottom2board () {
      let screenTop = this.drawData[0][0].z
      return this.boardH - this.scrnH - (screenTop - this.boardStatusTop)
    },

    projectorName () {
      return this.selectedModelData.value
    }
  },

  watch: {
    // this.intFuncStatus=0 ==> インタラクティブ機能 ON
    // this.intFuncStatus=1 ==> インタラクティブ機能 OFF
    // this.intFuncSupport インタラクティブがサポートするかどうか
    selectRatioData (newValue, oldValue) {
      if (this.intFuncSupport && this.intFuncStatus === 0) {
        this.SET_RATIOSCREENSIZEMIN(newValue.whiteboardSize.min)
        this.SET_RATIOSCREENSIZEMAX(newValue.whiteboardSize.intOnMax)
      } else if (this.intFuncSupport && this.intFuncStatus === 1) {
        this.SET_RATIOSCREENSIZEMIN(newValue.screenSize.wall.min)
        this.SET_RATIOSCREENSIZEMAX(newValue.screenSize.wall.max)
      } else {
        // Position=0  デスクトップの場合
        // Position=1  天吊りの場合
        // Position=2  壁掛けの場合
        if (this.Position === 2) {
          this.SET_RATIOSCREENSIZEMIN(newValue.screenSize.wall.min)
          this.SET_RATIOSCREENSIZEMAX(newValue.screenSize.wall.max)
        } else {
          this.SET_RATIOSCREENSIZEMIN(newValue.screenSize.w.min)
          this.SET_RATIOSCREENSIZEMAX(newValue.screenSize.w.max)
        }
      }
    },

    screenSizeActive (newValue, oldValue) {
      if (this.screenSizeActive.length > 0) {
        this.dwhBool = true
        this.screenSizeCollapseClass = 'screen-size-collapse-open'
      } else {
        this.dwhBool = false
        this.screenSizeCollapseClass = 'screen-size-collapse-close'
      }
    },

    throwActive (newValue, oldValue) {
      if (this.throwActive.length > 0) {
        this.throwValBool = true
      } else {
        this.throwValBool = false
      }
    },
    real_throw_distance_checked (newValue, oldValue) {
      if (newValue) {
        this.screenSizeWidth()
      }
    },
    roomW (newValue, oldValue) {
      this.roomWData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },

    roomH (newValue, oldValue) {
      this.roomHData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
      if (this.isSimple) {
        this.ROOMW(this.roomH * 2)
        this.ROOMD(this.roomH * 4)
      }
    },

    roomD (newValue, oldValue) {
      this.roomDData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },

    pjY (newValue, oldValue) {
      let value = this.isUSTWall ? newValue - this.ustLensToFrontPj : newValue
      this.pjYData = this.$commonJs.changeUnit(value, this.graph.unit)
      // this.throwDisSliderw = this.$commonViewJs.getKy()
      // this.throwDisSlidert = this.$commonViewJs.getLy()
      this.SET_THROWDISSLIDERW(this.$commonViewJs.getKy())
      this.SET_THROWDISSLIDERT(this.$commonViewJs.getLy())
      if (this.ustThrowDisSlidertMax) {
        this.throwDisSlidert = this.ustThrowDisSlidertMax + this.ustLensToFrontPj
        if (this.throwDisSliderw > this.throwDisSlidert) this.throwDisSlidert = this.throwDisSliderw
      }
      if (!this.screen_size_checked) {
        // 获取黑边的长宽
        this.resetScreenByPjy()
      }
      if (!((this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) || this.selectedModelData.category === 4)) {
        let temPjx = this.graph.pjX
        let temPjz = this.graph.pjZ
        this.outRoomHeight = this.$commonViewJs.getMaxOutRoomH(this.initScreenSize.h)
        this.outRoomWidth = this.$commonViewJs.getMaxOutRoomW(this.initScreenSize.w)
        temPjz = this.$commonJs.checkRange(temPjz, -this.outRoomHeight + this.limitData, this.houseInfo.roomH - this.limitData)
        temPjx = this.$commonJs.checkRange(temPjx, -this.outRoomWidth + this.limitData, this.houseInfo.roomW + this.outRoomWidth - this.limitData)
        this.PJZ(temPjz)
        this.PJX(temPjx)
      }
    },

    scrnW (newValue, oldValue) {
      this.scrnWData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    scrnH (newValue, oldValue) {
      this.scrnHData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    boardW (newValue, oldValue) {
      this.boardWData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    boardH (newValue, oldValue) {
      this.boardHData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    offsetComputed (newValue, oldValue) {
      this.offsetData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    screenSizeDataComputed (newValue, oldValue) {
      this.screenSizeData = newValue
      let temPjx = this.graph.pjX
      let temPjz = this.graph.pjZ
      this.outRoomHeight = this.$commonViewJs.getMaxOutRoomH(this.initScreenSize.h)
      this.outRoomWidth = this.$commonViewJs.getMaxOutRoomW(this.initScreenSize.w)
      temPjz = this.$commonJs.checkRange(temPjz, -this.outRoomHeight + this.limitData, this.houseInfo.roomH - this.limitData)
      temPjx = this.$commonJs.checkRange(temPjx, -this.outRoomWidth + this.limitData, this.houseInfo.roomW + this.outRoomWidth - this.limitData)
      this.PJZ(temPjz)
      this.PJX(temPjx)
    },

    unit (newValue, oldValue) {
      this.roomWData = this.$commonJs.changeUnit(this.roomW, newValue, false, true)
      this.roomHData = this.$commonJs.changeUnit(this.roomH, newValue, false, true)
      this.roomDData = this.$commonJs.changeUnit(this.roomD, newValue, false, true)
      this.boardWData = this.$commonJs.changeUnit(this.boardW, newValue, false, true)
      this.boardHData = this.$commonJs.changeUnit(this.boardH, newValue, false, true)

      let value = this.isUSTWall ? this.pjY - this.ustLensToFrontPj : this.pjY
      this.pjYData = this.$commonJs.changeUnit(value, newValue)

      this.scrnWData = this.$commonJs.changeUnit(this.scrnW, newValue)
      this.scrnHData = this.$commonJs.changeUnit(this.scrnH, newValue)
      this.offsetData = this.$commonJs.changeUnit(this.offsetComputed, newValue)
      this.floor2footProjectorData = this.$commonJs.changeUnit(this.floor2footProjectorData, newValue)
      this.floor2bottomData = this.$commonJs.changeUnit(this.floor2bottomComputed, newValue)
    },

    f_d2sComputed (newValue, oldValue) {
      this.SELECTRATIODATA(this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData))
      this.changeDiagonal()
      this.changeDwhSelect()
      if (this.screen_size_checked) {
        this.changeDistanceOnSizeLocked()
      } if (this.throw_distance_checked) {
        this.changeDistanceOnThrowDisLocked()
      } else {
        this.changeDistance()
      }
    },

    gainComputed (newValue, oldValue) {
      this.gainData = newValue
    },

    vAngleDataComputed (newValue, oldValue) {
      this.vAngleData = newValue
    },

    hAngleDataComputed (newValue, oldValue) {
      this.hAngleData = newValue
    },

    drawData (newValue, oldValue) {
      if (newValue) {
        let data = this.drawData[0].reduce((data1, data2) => {
          return data1.z > data2.z ? data1 : data2
        })
        let temp = this.roomH - data.z - (this.whiteboardSupport && this.whiteboardStatus ? this.screenBottom2board : 0)
        if (temp < this.limitData) {
          temp = this.limitData
        }
        this.SET_FLOOR2BOTTOM(temp)
        this.floor2bottomData = this.$commonJs.changeUnit(this.floor2bottom, this.graph.unit)
        // this.floor2footProjectorData = this.position === 1 ? this.floor2footProjectorData : this.floor2footProjectorComputed
        this.floor2footProjectorData = this.floor2footProjectorComputed
        this.changeDiagonal()
      }
    },
    floor2bottom (newValue, oldValue) {
      this.floor2bottomData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },
    selectedModelData (newValue, oldValue) {
      this.SET_POSITION(newValue.position)
    },
    projectorName (newValue, oldValue) {
      if (this.whiteboardSupport && this.intFuncSupport) {
        this.intFuncStatus = 0
        this.changeDwhSelect()
      }
    },
    isUSTWall (val) {
      if (val) {
        this.SET_THROWDISTANCECHECKED(false)
        if (this.screenSizeChecked) {
          this.SET_SCREENSIZECHECKED(false)
          this.setSpecificInfo(this.selectedLensData)
        }
        this.SET_REALTHROWDISTANCECHECKED(false)
        this.SELECTRATIODATA(this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData))
        this.appSelect = '1'
        this.changeBrightness(this.appSelect)
        this.ROOMH(300)
        if (this.roomH > 500) {
          this.ROOMH(500)
        } else if (this.roomH < 200) {
          this.ROOMH(200)
        }
        let result = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        this.checkScreenSize(result)
      } else {
        if (!this.isHistoryRowClick) {
          this.ROOMH(500)
        }
      }

      let value = val ? this.graph.pjY - this.ustLensToFrontPj : this.graph.pjY
      this.pjYData = this.$commonJs.changeUnit(value, this.graph.unit)
    },
    touchDisable (newValue) {
      if (newValue) {
        this.touchStatus = 1
      }
    },
    isSimple (newValue, oldValue) {
      if (newValue) {
        this.screenSizeChange()
        this.throwDistanceChange()
        this.changeMutation('roomHData', 'SET_GRAPH_ROOMH', 'changeRoomH')
      }
    },
    angle_activeNames (newValue, oldValue) {
      if (newValue.indexOf('1') !== -1) {
        this.curve_activeNames = ['0']
      }
    },
    ambient_activeNames (newValue, oldValue) {
      if (newValue.indexOf('1') !== -1) {
        this.curve_activeNames = ['0']
      }
    },
    out_activeNames (newValue, oldValue) {
      if (newValue.indexOf('1') !== -1) {
        this.curve_activeNames = ['0']
      }
    },
    searchTabActive (newValue, oldValue) {
      if (newValue === 'CurvedSurface') {
        if (this.curveShape === '0') {
          this.dwhSelect = '1'
        } else {
          this.dwhSelect = '2'
        }
        this.SET_OFFSET(0)
      } else {
        this.dwhSelect = '0'
      }
      this.changeDwhSelect()
    },
    curveDirection (newValue, oldValue) {
      let minMaxDis = this.getPjyRange()
      let min = this.isFraction ? minMaxDis.min : this.$commonJs.changeUnit(minMaxDis.min, this.graph.unit, true)
      let max = this.isFraction ? minMaxDis.max : this.$commonJs.changeUnit(minMaxDis.max, this.graph.unit, true)
      max = (max > this.$commonViewJs.getMaxDisByRoom() ? this.$commonViewJs.getMaxDisByRoom() : this.$commonViewJs.getLy()) - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0)
      let value
      if (oldValue === '0' && newValue === '1') {
        value = this.graph.pjY - this.curveDepth
      } else if (oldValue === '1' && newValue === '0') {
        value = this.graph.pjY + this.curveDepth
      }
      value = this.$commonJs.checkRange(value, min, max)
      this.PJY(value)
    },
    // 监听ボードの厚み最大值 超过最大值 ボードの厚みthis.offsetData=ustOffsetMax
    ustOffsetMax (newValue, oldValue) {
      if (this.offsetData > newValue) {
        this.offsetData = newValue
        this.SET_OFFSET(this.$commonJs.changeUnit(newValue, this.graph.unit, true))
      }
    },
    vAngleFlagData (newValue, oldValue) {
      if (!newValue) {
        this.vAngleData = '0'
        this.SET_VANGLE(0)
      }
    },
    hAngleFlagData (newValue, oldValue) {
      if (!newValue) {
        this.hAngleData = '0'
        this.SET_HANGLE(0)
      }
    }
  },

  directives: {
    showTip (el, binding, vnode) {
      let se = vnode.context.dwhSelect
      let tip = se === '0' ? vnode.context.screenSizeData : (se === '1' ? vnode.context.scrnWData : (se === '2' ? vnode.context.scrnHData : 0))
      let target = el.getElementsByClassName('el-slider__button-wrapper')[0]
      if (target.getElementsByTagName('label')[0]) {
        target.getElementsByTagName('label')[0].innerText = tip
      } else {
        let addNode = `<label class="lab" style="position: absolute;top: -7px;width: max-content;">` + tip + `</label>`
        target.innerHTML = addNode + target.innerHTML
      }
    },
    showTipDis (el, binding, vnode) {
      let target = el.getElementsByClassName('el-slider__button-wrapper')[0]
      if (!vnode.context.real_throw_distance_checked) {
        if (target.getElementsByTagName('label')[0]) {
          target.getElementsByTagName('label')[0].remove()
        }
        return
      }
      let tip = vnode.context.pjYData
      if (target.getElementsByTagName('label')[0]) {
        target.getElementsByTagName('label')[0].innerText = tip
      } else {
        let addNode = `<label class="lab" v-if="false" style="position: absolute;top: -7px;width: max-content;">` + tip + `</label>`
        target.innerHTML = addNode + target.innerHTML
      }
    }
  },
  components: {
    inputValidateBox,
    Resultbrightnessguide,
    SimpleItem,
    CurveCondition,
    FtInput
  }
}
</script>

<style scoped>
  .condition {
    height: 960px;
    border: 2px solid #bdbdbd;
    overflow: hidden;
    background-color: #f0f0f0;
  }

  .condition-room {
    padding: 5px 0px;
    float: right;
  }

  .condition span {
    font-size: 14px;
  }

  .condition-title {
    font-weight: bold;
    background: #bbbbbb;
    padding: 6px 10px;
    border-bottom: 0px solid #bdbdbd;
  }

  .room-input {
    padding: 5px 0px 5px 10px;
    font-size: 14px;
  }
  .board-input {
    padding: 0px 0px 5px 10px;
    font-size: 14px;
  }
  .room_size,
  .screen_size {
    padding: 10px 17px 9px;
  }

  .room-title,
  .position-title {
    width: 85px;
    float: left;
    line-height: 26px;
  }

  .condition tr {
    font-size: 14px;
  }

  .room_block {
    width: 55px;
  }

  .screen-size {
    padding: 10px 23px 5px 10px;
  }

  .screen-size-span {
    font-weight: bold;
  }

  .screen-diagonal {
    display: inline-block;
  }

  .screen_size_floor {
    line-height: 26px;
    padding: 10px 10px 0px;
  }

  .screen_size_floor_ust {
    line-height: 26px;
    padding: 0px 10px 10px 10px;
  }

  .room_size span,
  .screen_size span {
    text-align: center;
    display: block;
  }

  .room_size span:nth-child(2),
  .screen_size span:nth-child(2) {
    padding: 8px 0px 4px;
  }

  .throw_distance {
    line-height: 26px;
    padding: 5px 10px;
  }

  .birghtness {
    line-height: 26px;
    padding: 5px 0px 5px 10px;
    background: #f0f0f0;
  }
  .screen_size_offset {
    line-height: 26px;
    padding: 5px 10px 10px;
  }

  .vertical_switch {
    line-height: 26px;
    padding: 10px;
    background: #f0f0f0;
  }

  .screen_size_aspect {
    line-height: 26px;
    padding: 5px 10px 5px;
    display: inline-block;
    width: 100%;
  }

  .ambient_application {
    line-height: 26px;
    padding: 10px 10px 0px;
    background: #f0f0f0;
  }

  .ambient_screengain {
    line-height: 26px;
    padding: 0px 10px 5px;
    background: #f0f0f0;
  }

  span.m {
    margin-left: 2px;
  }

  .horizonal_switch {
    line-height: 26px;
    padding: 0px 10px 10px;
    background: #f0f0f0;
  }

  .out_switch {
    background: #f0f0f0;
    padding: 10px;
  }

  .checkbox {
    float: right;
  }
  .out_of_spec_item{
    position: relative;
  }
  .waring-icon {
    position: absolute;
    right: 40px;
    width: 18px;
    height: 18px;
    top: 5px;
    background: url('../../assets/parts/icon/TDC_warning.png') no-repeat center;
  }

  .suo-icon {
    width: 18px;
    height: 18px;
    background: url('../../assets/parts/icon/TDC_lock.png') no-repeat center;
    float: left;
    margin-right: 5px;
  }

  .unit {
    display: inline-block;
    width: 20px;
    margin-left: -3px;
    padding-right: 6px;
  }

  .condition__bottom_radio {
    line-height: 26px;
    padding: 0px 10px;
    display: inline-block;
    width: 100%;
  }

  .aspect_ratio {
    float: left;
    width: 148px;
  }

  .screen-position {
    float: left;
    width: 233px;
  }

  .ratio-select {
    float: right;
    width: 140px;
    margin-right: 34px;
  }
  .screen-select {
    float: left;
    width: 120px;
    margin-right: 28px;
  }

  .screen-position_input {
    display: inline-block;
    width: 100%;
    text-align: right;
  }

  .vertical_text {
    float: left;
    width: 175px;
  }

  .indicate_switch{
    position: relative;
    /* line-height: 26px; */
    padding: 10px 10px 0 10px;
    background: #f0f0f0;
  }
  .indicate_text {
    width: 220px;
    display: inline-block;
  }
  .indicate_switch_btn{
    display: inline-block;
    position: absolute;
    right: 45px;
  }
.switch,
.project-angle_input {
  float: left;
}
.out_of_spec_dialog p{
  font-size: 14px;
  color: #666666;
  word-break: break-word;
}
.out_of_spec_dialog>>>.el-dialog__header {
  height: 180px;
  background: url('../../assets/parts/graph/out_of_spec_warning.png') no-repeat center;
}
.out_of_spec_dialog>>>.el-dialog__body{
  padding: 30px 25px;
}
.out_of_spec_dialog>>>.el-dialog__footer{
  padding:0 20px 40px 20px
}
.out_of_spec_dialog .el-button>>>span{
  padding: 10px
}
.dwh_out_of_spec>>>.el-input__inner{
  background: #f7baf7
}
.switch,
.project-angle_input {
  float: left;
}

.lab {
position: relative;
top: -5px;
}
.curved_shape{
  padding: 10px 10px 0 10px;
  line-height: 26px;
  background: #f0f0f0;
}
.span_container {
  float: left;
  width: 148px;
}
.select_container {
  float: right;
  width: 140px;
  margin-right: 34px;
}
</style>

<style type="text/css">
  .bgYellow .el-input__inner {
    background: yellow;
  }

  .sld {
    position: relative;
    padding: 10px 10px 5px 10px;
  }

  .border {
    position: relative;
    top: 22px;
    border: 1px solid #999
  }

  .pjy-slider {
    position: relative;
    z-index: 999;
  }

  .screen_size_sld, .throw_dis_sld {
    line-height: 10px;
  }

  .condition_sliderbar {
    /* overflow:hidden; */
    position: relative;
    width: 90%;
    margin: auto;
  }

  .check {
    position: absolute;
    width: 100%;
    top: 2px;
  }

  .none .el-slider__button-wrapper {
    display: none;
  }

  .block .el-slider__button-wrapper {
    display: block;
  }
  .el-scrollbar__bar.is-horizontal {
    display: none;
  }
  .out_of_spec_warning{
    padding-left: 10px
  }
  .out_of_spec_title{
    max-width: 250px;
  }
  .out_of_spec_warning img{
    vertical-align: middle
  }
  .out_of_spec_warning span{
    vertical-align: middle;
    color: red
  }

/* .simple-condition {
  position: absolute;
  right: 20px;
  top: 20px;
} */

.simple-item-box {
  margin-right: 10px;
}

.simple-aspect {
  margin: 5px 0px;
}

.simple-mode {
  margin-top: 20px;
}

.simple-item-title {
  color: #fff;
  font-size: 14px;
  display: block;
  /* overflow: hidden; */
  white-space: nowrap;
  text-overflow: ellipsis;
}

.simple-item-val {
  background: none;
  margin-top: 5px;
  border: 1px solid #fff;
}

.ceiling-height{
  position: absolute;
  top: 300px;
  left: 56px;
}

.simple-item-clh {
  width: auto;
  min-width: 140px;
  height: 72px;
  background: rgba(0,0,0,.6);
  color: #fff;
  font-size: 14px;
  position: relative;
  z-index: 10;
}
.simple-item-clh-box {
  height: 100%;
  width: 6px;
  float: left;
}
.ceiling-height-color {
  background: #191970;
}
.simple-item-clh-title{
  padding-left: 12px;
  padding-top: 5px;
  line-height: 16px;
}
.simple-item-clh-val{
  bottom: 10px;
  right: 10px;
  font-weight: bold;
  position: absolute;
}

.simple-item-clh-ft-val {
  width: 155px;
  margin: 15px 0px 0px 11px;
}

.simple-item-clh-inch-val {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.simple_condition {
  position: relative;
  z-index: 999;
}

.simplt-item {
  /* position: absolute; */
  width: 400px;
  border: none;
  background-color: rgba(0,0,0,.6);
  /* top: 5px; */
  /* left: 5px; */
}

.screen-size-collapse {
  position: absolute;
  right: 0px;
  top: -2px;
}

.screen-size-collapse-open {
  width: auto;
  min-width: 410px;
}

.screen-size-collapse-close {
  width: auto;
  min-width: 410px;
}

.param-color-pink {
  border-left: 4px solid #ff3399;
}

.param-color-blue {
  border-left: 4px solid #00b0f0;
}

.simple-item-val-dwh {
  position: absolute;
  right: 60px;
  /* top: 0px; */
}

.item-val {
  display: inline-block;
}

.item-val-disable {
  display: inline-block;
}

.simple-screensize {
  padding: 5px 10px 0px;
}

.simple-screensize .item {
  width: 120px;
  display: inline-block;
  font-size: 14px;
}

.simple-item-val-d {
  position: absolute;
  /* top: 10px; */
  right: 15px;
  color: #fff;
  /* margin-top: 10px; */
}

.simple-unit {
  color: #fff;
  font-size: 14px;
}

.screen-size-dwh {
  width: calc(100% - 14px);
  color: #fff;
  position: absolute;
  /* right: 15px; */
  top: 30px;
  padding-right: 10px;
}

.simple-lens {
  height: 30px;
  line-height: 30px;
  background: none;
  margin-top: 15px;
}

.simple-brightness {
  height: 30px;
  line-height: 30px;
  background: none;
  margin-top: 5px;
}

.simple-title {
  color: #fff;
  font-size: 14px;
}

.simple-lens-val {
  float: right;
}

.screen-size-collapse-close .simple-screen-title {
  position: absolute;
  top: 5px;
}

.throw-distance-collapse {
  position: relative;
  margin-top: 2px;
}

.simple-throw-val {
  position: absolute;
  right: 50px;
  width: 120px
}

.simple-mode-val {
  background: none;
  margin-top: 5px;
  border: 1px solid #fff;
}

.simple-throw-val-input {
  position: absolute;
  right: 50px;
  /* margin-top: 5px; */
}

.distance-from-floor {
  padding: 0;
}

.lens-shift-range {
  font-size: 14px;
  color: #fff;
  margin-top: 2px;
}

.range-title {
  background-color: #005ab4;
  height: 30px;
  line-height: 30px;
  padding: 0 15px;
}

.range-item {
  height: 30px;
  line-height: 30px;
  background-color: rgba(0,0,0,.5);
  padding: 0 15px;
}

.range-val {
  float: right;
}

.range-list-box {
  border-radius: 50%;
  height: 18px;
  width: 18px;
  display: inline-block;
  background: #fff;
  vertical-align: middle;
  border: 1px solid #4277bf;
}

.rang-list {
  display: block;
  color: #4277bf;
  height: 18px;
  line-height: 18px;
  text-align: center;
}

.range-item hr {
  background-color: #f5f0f0;
}

.ft_inch_val .input1 {
  width: 35px;
}

.ft_inch_val .input2 {
  width: 30px;
}

.ft_inch_val .input3 {
  width: 20px;
}

.ft_inch_val .input4 {
  width: 25px;
}

.ft_inch-ft-w, .ft_inch-inch-w {
  position: absolute;
  right: 30px;
  top: 35px;
}

.ft_inch-ft-h, .ft_inch-inch-h {
  text-align: right;
  margin-right: 20px;
}

.ftf_throw-distance {
  position: absolute;
  right: 50px;
  color: #fff;
}
.ftf_throw-distance_feet{
  /* right: 30px; */
  top:10px
}
.screensize-collapse {
  position: relative;
  margin-top: 2px;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.lens-shift-range .simple-item {
  margin-top: 0 !important;
}

.brightness-input {
  text-align: right;
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
}

/* .isWallDisable {
  disabled: true;
} */

.lens-shift-range-title {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  background-color: rgba(0,0,0,.6);
  border-left: 4px solid #000000;
  padding-left: 10px;
}

.disable_none {
  display: none;
}

.screen-size_sliderbar {
  width: 90%;
  margin: auto;
}

.screen-size_sliderbar .lab {
  font-size: 14px;
}

.condition_sliderbar .lab {
  font-size: 14px;
}

.dwh_bool {
  top: 4px;
}

.p-right {
  text-align: right;
  padding-right: 50px;
}

.room-test {
  display: inline-block;
  font-weight: bold;
}

.w-title {
  display: inline-block;
  width: 50px;
  font-weight: bold;
}

.w-title2 {
  display: inline-block;
  width: 300px;
}

.w-value {
  display: inline-block;
  width: 185px;
  text-align: right;
}

.roomsize-title {
  /* float:left; */
  /* width:85px; */
  /* height:78px; */
  line-height: 1.5;
}

.room_block_input {
  display: inline-block;
  width: 100%;
}

.ft_inch_item {
  display: inline-block;
  width: 100%;
  text-align: right;
  white-space: nowrap;
}

.ft_inch_item-wdith {
  width: calc(100% - 65px);
  white-space: nowrap;
}

.ft_inch_item-wdith2 {
  position: relative;
  top: -13px;
  width: calc(100% - 10px);
  white-space: nowrap;

}

.screensize-wdh {
  float: left;
  width: 170px;
}
.out_of_spec_warning_span{
  max-width: 200px;
}
.lock-floor{
  margin-right: 100px;
  position: relative;
  top: 10px;
}
.lock-floor-fraction{
  position: relative;
  top: 10px;
  margin-right: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/condition/condition.vue